// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Stylus Helper Styles */
@-moz-keyframes heartbeat {
  0% {
    transform: translate(-50%, -50%) scale(0.75);
  }
  20% {
    transform: translate(-50%, -50%) scale(0.75);
  }
  23% {
    transform: translate(-50%, -50%) scale(1);
  }
  26% {
    transform: translate(-50%, -50%) scale(0.75);
  }
  27% {
    transform: translate(-50%, -50%) scale(0.75);
  }
  29% {
    transform: translate(-50%, -50%) scale(1);
  }
  31% {
    transform: translate(-50%, -50%) scale(0.8);
  }
  100% {
    transform: translate(-50%, -50%) scale(0.75);
  }
}
@-webkit-keyframes heartbeat {
  0% {
    transform: translate(-50%, -50%) scale(0.75);
  }
  20% {
    transform: translate(-50%, -50%) scale(0.75);
  }
  23% {
    transform: translate(-50%, -50%) scale(1);
  }
  26% {
    transform: translate(-50%, -50%) scale(0.75);
  }
  27% {
    transform: translate(-50%, -50%) scale(0.75);
  }
  29% {
    transform: translate(-50%, -50%) scale(1);
  }
  31% {
    transform: translate(-50%, -50%) scale(0.8);
  }
  100% {
    transform: translate(-50%, -50%) scale(0.75);
  }
}
@-o-keyframes heartbeat {
  0% {
    transform: translate(-50%, -50%) scale(0.75);
  }
  20% {
    transform: translate(-50%, -50%) scale(0.75);
  }
  23% {
    transform: translate(-50%, -50%) scale(1);
  }
  26% {
    transform: translate(-50%, -50%) scale(0.75);
  }
  27% {
    transform: translate(-50%, -50%) scale(0.75);
  }
  29% {
    transform: translate(-50%, -50%) scale(1);
  }
  31% {
    transform: translate(-50%, -50%) scale(0.8);
  }
  100% {
    transform: translate(-50%, -50%) scale(0.75);
  }
}
@keyframes heartbeat {
  0% {
    transform: translate(-50%, -50%) scale(0.75);
  }
  20% {
    transform: translate(-50%, -50%) scale(0.75);
  }
  23% {
    transform: translate(-50%, -50%) scale(1);
  }
  26% {
    transform: translate(-50%, -50%) scale(0.75);
  }
  27% {
    transform: translate(-50%, -50%) scale(0.75);
  }
  29% {
    transform: translate(-50%, -50%) scale(1);
  }
  31% {
    transform: translate(-50%, -50%) scale(0.8);
  }
  100% {
    transform: translate(-50%, -50%) scale(0.75);
  }
}
@-moz-keyframes pulse {
  0% {
    transform: translate(-50%, -50%) rotate(0) scale(0);
    opacity: 1;
  }
  50% {
    transform: translate(-50%, -50%) rotate(var(--rotate)) scale(1);
    opacity: 0;
  }
  100% {
    transform: translate(-50%, -50%) rotate(0) scale(2);
    opacity: 0;
  }
}
@-webkit-keyframes pulse {
  0% {
    transform: translate(-50%, -50%) rotate(0) scale(0);
    opacity: 1;
  }
  50% {
    transform: translate(-50%, -50%) rotate(var(--rotate)) scale(1);
    opacity: 0;
  }
  100% {
    transform: translate(-50%, -50%) rotate(0) scale(2);
    opacity: 0;
  }
}
@-o-keyframes pulse {
  0% {
    transform: translate(-50%, -50%) rotate(0) scale(0);
    opacity: 1;
  }
  50% {
    transform: translate(-50%, -50%) rotate(var(--rotate)) scale(1);
    opacity: 0;
  }
  100% {
    transform: translate(-50%, -50%) rotate(0) scale(2);
    opacity: 0;
  }
}
@keyframes pulse {
  0% {
    transform: translate(-50%, -50%) rotate(0) scale(0);
    opacity: 1;
  }
  50% {
    transform: translate(-50%, -50%) rotate(var(--rotate)) scale(1);
    opacity: 0;
  }
  100% {
    transform: translate(-50%, -50%) rotate(0) scale(2);
    opacity: 0;
  }
}
@-moz-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-o-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-moz-keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@-webkit-keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@-o-keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@-moz-keyframes grow {
  from {
    transform: scale(0.1);
  }
  to {
    transform: scale(1);
  }
}
@-webkit-keyframes grow {
  from {
    transform: scale(0.1);
  }
  to {
    transform: scale(1);
  }
}
@-o-keyframes grow {
  from {
    transform: scale(0.1);
  }
  to {
    transform: scale(1);
  }
}
@keyframes grow {
  from {
    transform: scale(0.1);
  }
  to {
    transform: scale(1);
  }
}
@-moz-keyframes poof {
  from {
    transform: scale(0) rotate(0deg);
    opacity: 1;
  }
  to {
    transform: scale(1) rotate(720deg);
    opacity: 0;
  }
}
@-webkit-keyframes poof {
  from {
    transform: scale(0) rotate(0deg);
    opacity: 1;
  }
  to {
    transform: scale(1) rotate(720deg);
    opacity: 0;
  }
}
@-o-keyframes poof {
  from {
    transform: scale(0) rotate(0deg);
    opacity: 1;
  }
  to {
    transform: scale(1) rotate(720deg);
    opacity: 0;
  }
}
@keyframes poof {
  from {
    transform: scale(0) rotate(0deg);
    opacity: 1;
  }
  to {
    transform: scale(1) rotate(720deg);
    opacity: 0;
  }
}
@-moz-keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@-moz-keyframes spin-grow {
  0% {
    transform: rotate(0deg) scale(1) translateZ(0);
  }
  50% {
    transform: rotate(360deg) scale(3) translateZ(0);
  }
  100% {
    transform: rotate(0deg) scale(1) translateZ(0);
  }
}
@-webkit-keyframes spin-grow {
  0% {
    transform: rotate(0deg) scale(1) translateZ(0);
  }
  50% {
    transform: rotate(360deg) scale(3) translateZ(0);
  }
  100% {
    transform: rotate(0deg) scale(1) translateZ(0);
  }
}
@-o-keyframes spin-grow {
  0% {
    transform: rotate(0deg) scale(1) translateZ(0);
  }
  50% {
    transform: rotate(360deg) scale(3) translateZ(0);
  }
  100% {
    transform: rotate(0deg) scale(1) translateZ(0);
  }
}
@keyframes spin-grow {
  0% {
    transform: rotate(0deg) scale(1) translateZ(0);
  }
  50% {
    transform: rotate(360deg) scale(3) translateZ(0);
  }
  100% {
    transform: rotate(0deg) scale(1) translateZ(0);
  }
}
@-moz-keyframes gradient {
  0% {
    background-position: 0 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
@-webkit-keyframes gradient {
  0% {
    background-position: 0 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
@-o-keyframes gradient {
  0% {
    background-position: 0 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
@keyframes gradient {
  0% {
    background-position: 0 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
:root {
  --p3events-color-text-base: #000;
  --p3events-color-black: #000;
  --p3events-color-white: #fff;
  --p3events-color-primary: #12543b;
  --p3events-color-secondary: #7b3219;
  --p3events-color-accent: #ffe4a8;
  --p3events-color-neutral: #fff;
  --p3events-color-canvas: #061733;
  --p3events-color-canvas-darker: #0c1424;
  --p3events-color-canvas-lighter: #264773;
  --p3events-color-success: #2d7b59;
  --p3events-color-warning: #a02327;
  --p3events-color-error: #473362;
  --p3events-font-family: "Noto Sans", sans-serif;
  --p3events-font-family-alt: "Dosis", serif;
  --p3events-font-family-headings: "Signika", serif;
  --p3events-font-family-stylish: "Permanent Marker", serif;
  --p3events-font-family-icon: 'Font Awesome 6 Pro', 'Font Awesome 6 Free';
  --p3events-font-family-icon-brands: 'Font Awesome 6 Brands';
  --p3events-base-text-color: var(--p3events-color-canvas-contrast);
  --p3events-base-text-color-alt: var(--p3events-color-secondary);
  --p3events-icon-font-size: 1rem;
  --p3events-btn-icon-font-size: 1.5rem;
  --p3events-btn-bg-depth-shadow: var(--p3events-color-black);
  --p3events-btn-bg-depth-border: var(--p3events-color-black);
  --p3events-btn-bg-depth-shadow-opacity: 0.1;
  --p3events-btn-bg-depth-border-opacity: 0.15;
  --p3events-btn-bg-depth-shadow-blend: overlay;
  --p3events-btn-bg-depth-border-blend: overlay;
  --p3events-btn-bg-depth-shadow-hover: var(--p3events-color-white);
  --p3events-btn-bg-depth-border-hover: var(--p3events-color-white);
  --p3events-btn-bg-depth-shadow-opacity-hover: 0.15;
  --p3events-btn-bg-depth-border-opacity-hover: 0.5;
  --ll-btn-ripple-color: rgba(255,255,255,0.25);
  --p3events-easing: cubic-bezier(0.23, 1, 0.32, 1);
  --p3events-transition-timing: 0.25s;
  --p3events-transition: var(--p3events-transition-timing) var(--p3events-easing);
  --p3events-border-radius: 12px;
  --p3events-pulse-bg-color: var(--p3events-color-canvas-lighter);
  --p3events-pulse-max-size: 72px;
  --p3events-box-shadow: 0 0 8px rgba(0,0,0,0.5);
  --p3events-box-shadow-light: 0 2px 4px rgba(0,0,0,0.1);
  --p3events-box-shadow-bottom: 0 8px 8px -8px rgba(0,0,0,0.5);
  --p3events-body-font-family: var(--p3events-font-family);
  --p3events-body-font-size: 1.125rem;
  --p3events-link-color: #aaa;
  --p3events-link-color-hover: var(--p3events-color-secondary);
  --p3events-contain-margin: 1rem;
  --p3events-contain-tablet-portrait-margin: calc(7.5% - 16px);
  --p3events-contain-tablet-landscape-margin: var(--p3events-contain-tablet-portrait-margin);
  --p3events-contain-desktop-margin: 5%;
  --p3events-header-bg-color: var(--p3events-color-canvas-darker);
  --p3events-header-border-bottom-width: 3px;
  --p3events-header-height-mobile: 6rem;
  --p3events-header-height: 7.8125rem;
  --p3events-site-links-item-padding: 1.5rem;
  --p3events-site-links-profile-icon-color: var(--p3events-color-accent);
  --p3events-cart-icon-bg-color: var(--p3events-color-canvas-lighter);
  --p3events-cart-icon-bg-opacity: 0.1;
  --p3events-banner-height: 25rem;
  --p3events-navigation-height-mobile: calc(100dvh - var(--p3events-header-height-mobile));
  --p3events-navigation-height: calc(100dvh - var(--p3events-header-height));
  --p3events-navigation-height-admin-mobile: calc(100dvh - (var(--p3events-header-height-mobile) + 46px));
  --p3events-navigation-height-admin: calc(100dvh - (var(--p3events-header-height) + 32px));
  --p3events-navigation-top-mobile: var(--p3events-header-height-mobile);
  --p3events-navigation-top: var(--p3events-header-height);
  --p3events-navigation-top-admin-mobile: calc(var(--p3events-header-height-mobile) + 46px);
  --p3events-navigation-top-admin: calc(var(--p3events-header-height) + 32px);
  --p3events-page-content-padding: 2rem;
  --p3events-heading-font-family: var(--p3events-font-family);
  --p3events-h1-font-family: var(--p3events-heading-font-family);
  --p3events-h2-font-family: var(--p3events-heading-font-family);
  --p3events-h3-font-family: var(--p3events-heading-font-family);
  --p3events-h4-font-family: var(--p3events-heading-font-family);
  --p3events-h5-font-family: var(--p3events-heading-font-family);
  --p3events-h6-font-family: var(--p3events-heading-font-family);
  --p3events-h1-font-size: 2.25rem;
  --p3events-h2-font-size: 2rem;
  --p3events-h3-font-size: 1.75rem;
  --p3events-h4-font-size: 1.5rem;
  --p3events-h5-font-size: 1.32rem;
  --p3events-h6-font-size: 1.12rem;
  --p3events-h1-font-size-mobile: 2rem;
  --p3events-h2-font-size-mobile: 1.75rem;
  --p3events-h3-font-size-mobile: 1.5rem;
  --p3events-h4-font-size-mobile: 1.32rem;
  --p3events-h5-font-size-mobile: 1.12rem;
  --p3events-h6-font-size-mobile: 1rem;
  --p3events-h1-font-weight: 700;
  --p3events-h2-font-weight: 500;
  --p3events-h3-font-weight: 500;
  --p3events-h4-font-weight: 400;
  --p3events-h5-font-weight: 300;
  --p3events-h6-font-weight: 700;
  --p3events-h1-text-color: var(--p3events-base-text-color);
  --p3events-h2-text-color: var(--p3events-base-text-color);
  --p3events-h3-text-color: var(--p3events-base-text-color-alt);
  --p3events-h4-text-color: var(--p3events-base-text-color);
  --p3events-h5-text-color: var(--p3events-base-text-color-alt);
  --p3events-h6-text-color: var(--p3events-base-text-color);
  --p3events-h1-text-transform: uppercase;
  --p3events-h2-text-transform: none;
  --p3events-h3-text-transform: none;
  --p3events-h4-text-transform: none;
  --p3events-h5-text-transform: none;
  --p3events-h6-text-transform: uppercase;
  --p3events-h1-font-weight-white: var(--p3events-h1-font-weight);
  --p3events-h2-font-weight-white: 700;
  --p3events-h3-font-weight-white: 700;
  --p3events-h4-font-weight-white: var(--p3events-h4-font-weight);
  --p3events-h5-font-weight-white: var(--p3events-h5-font-weight);
  --p3events-h6-font-weight-white: var(--p3events-h6-font-weight);
  --p3events-month-picker-icon-bg: var(--primary-300);
  --p3events-month-day-heading-bg-color: rgba(33,37,41,0.5);
  --p3events-month-day-heading-text-color: #fff;
}
.p3-events-plugin .contain {
  margin-right: var(--p3events-contain-margin);
  margin-left: var(--p3events-contain-margin);
}
@media (min-width: 768px) {
  .p3-events-plugin .contain {
    margin-right: var(--p3events-contain-tablet-portrait-margin);
    margin-left: var(--p3events-contain-tablet-portrait-margin);
  }
}
@media (min-width: 992px) {
  .p3-events-plugin .contain {
    margin-right: var(--p3events-contain-tablet-landscape-margin);
    margin-left: var(--p3events-contain-tablet-landscape-margin);
  }
}
@media (min-width: 1200px) {
  .p3-events-plugin .contain {
    margin-right: var(--p3events-contain-desktop-margin);
    margin-left: var(--p3events-contain-desktop-margin);
  }
}
.p3-events-plugin .contain-padding {
  padding-right: var(--p3events-contain-margin);
  padding-left: var(--p3events-contain-margin);
}
@media (min-width: 768px) {
  .p3-events-plugin .contain-padding {
    padding-right: var(--p3events-contain-tablet-portrait-margin);
    padding-left: var(--p3events-contain-tablet-portrait-margin);
  }
}
@media (min-width: 992px) {
  .p3-events-plugin .contain-padding {
    padding-right: var(--p3events-contain-tablet-landscape-margin);
    padding-left: var(--p3events-contain-tablet-landscape-margin);
  }
}
@media (min-width: 1200px) {
  .p3-events-plugin .contain-padding {
    padding-right: var(--p3events-contain-desktop-margin);
    padding-left: var(--p3events-contain-desktop-margin);
  }
}
@media (max-width: 576px) {
  .p3-events-plugin .contain-sm {
    margin-right: var(--p3events-contain-margin);
    margin-left: var(--p3events-contain-margin);
  }
}
@media (max-width: 576px) and (min-width: 768px) {
  .p3-events-plugin .contain-sm {
    margin-right: var(--p3events-contain-tablet-portrait-margin);
    margin-left: var(--p3events-contain-tablet-portrait-margin);
  }
}
@media (max-width: 576px) and (min-width: 992px) {
  .p3-events-plugin .contain-sm {
    margin-right: var(--p3events-contain-tablet-landscape-margin);
    margin-left: var(--p3events-contain-tablet-landscape-margin);
  }
}
@media (max-width: 576px) and (min-width: 1200px) {
  .p3-events-plugin .contain-sm {
    margin-right: var(--p3events-contain-desktop-margin);
    margin-left: var(--p3events-contain-desktop-margin);
  }
}
@media (max-width: 768px) {
  .p3-events-plugin .contain-md-down {
    margin-right: var(--p3events-contain-margin);
    margin-left: var(--p3events-contain-margin);
  }
}
@media (max-width: 768px) and (min-width: 768px) {
  .p3-events-plugin .contain-md-down {
    margin-right: var(--p3events-contain-tablet-portrait-margin);
    margin-left: var(--p3events-contain-tablet-portrait-margin);
  }
}
@media (max-width: 768px) and (min-width: 992px) {
  .p3-events-plugin .contain-md-down {
    margin-right: var(--p3events-contain-tablet-landscape-margin);
    margin-left: var(--p3events-contain-tablet-landscape-margin);
  }
}
@media (max-width: 768px) and (min-width: 1200px) {
  .p3-events-plugin .contain-md-down {
    margin-right: var(--p3events-contain-desktop-margin);
    margin-left: var(--p3events-contain-desktop-margin);
  }
}
@media (max-width: 768px) {
  .p3-events-plugin .contain-padding-md-down {
    padding-right: var(--p3events-contain-margin);
    padding-left: var(--p3events-contain-margin);
  }
}
@media (max-width: 768px) and (min-width: 768px) {
  .p3-events-plugin .contain-padding-md-down {
    padding-right: var(--p3events-contain-tablet-portrait-margin);
    padding-left: var(--p3events-contain-tablet-portrait-margin);
  }
}
@media (max-width: 768px) and (min-width: 992px) {
  .p3-events-plugin .contain-padding-md-down {
    padding-right: var(--p3events-contain-tablet-landscape-margin);
    padding-left: var(--p3events-contain-tablet-landscape-margin);
  }
}
@media (max-width: 768px) and (min-width: 1200px) {
  .p3-events-plugin .contain-padding-md-down {
    padding-right: var(--p3events-contain-desktop-margin);
    padding-left: var(--p3events-contain-desktop-margin);
  }
}
.p3-events-plugin .contain-children > *:not(.alignfull) {
  margin-right: var(--p3events-contain-margin);
  margin-left: var(--p3events-contain-margin);
}
@media (min-width: 768px) {
  .p3-events-plugin .contain-children > *:not(.alignfull) {
    margin-right: var(--p3events-contain-tablet-portrait-margin);
    margin-left: var(--p3events-contain-tablet-portrait-margin);
  }
}
@media (min-width: 992px) {
  .p3-events-plugin .contain-children > *:not(.alignfull) {
    margin-right: var(--p3events-contain-tablet-landscape-margin);
    margin-left: var(--p3events-contain-tablet-landscape-margin);
  }
}
@media (min-width: 1200px) {
  .p3-events-plugin .contain-children > *:not(.alignfull) {
    margin-right: var(--p3events-contain-desktop-margin);
    margin-left: var(--p3events-contain-desktop-margin);
  }
}
@media (max-width: 768px) {
  .p3-events-plugin .contain-children-md-down > *:not(.alignfull) {
    margin-right: var(--p3events-contain-margin);
    margin-left: var(--p3events-contain-margin);
  }
}
@media (max-width: 768px) and (min-width: 768px) {
  .p3-events-plugin .contain-children-md-down > *:not(.alignfull) {
    margin-right: var(--p3events-contain-tablet-portrait-margin);
    margin-left: var(--p3events-contain-tablet-portrait-margin);
  }
}
@media (max-width: 768px) and (min-width: 992px) {
  .p3-events-plugin .contain-children-md-down > *:not(.alignfull) {
    margin-right: var(--p3events-contain-tablet-landscape-margin);
    margin-left: var(--p3events-contain-tablet-landscape-margin);
  }
}
@media (max-width: 768px) and (min-width: 1200px) {
  .p3-events-plugin .contain-children-md-down > *:not(.alignfull) {
    margin-right: var(--p3events-contain-desktop-margin);
    margin-left: var(--p3events-contain-desktop-margin);
  }
}
@media (max-width: 768px) {
  .p3-events-plugin .contain-padding-children-md-down > *:not(.alignfull) {
    padding-right: var(--p3events-contain-margin);
    padding-left: var(--p3events-contain-margin);
  }
}
@media (max-width: 768px) and (min-width: 768px) {
  .p3-events-plugin .contain-padding-children-md-down > *:not(.alignfull) {
    padding-right: var(--p3events-contain-tablet-portrait-margin);
    padding-left: var(--p3events-contain-tablet-portrait-margin);
  }
}
@media (max-width: 768px) and (min-width: 992px) {
  .p3-events-plugin .contain-padding-children-md-down > *:not(.alignfull) {
    padding-right: var(--p3events-contain-tablet-landscape-margin);
    padding-left: var(--p3events-contain-tablet-landscape-margin);
  }
}
@media (max-width: 768px) and (min-width: 1200px) {
  .p3-events-plugin .contain-padding-children-md-down > *:not(.alignfull) {
    padding-right: var(--p3events-contain-desktop-margin);
    padding-left: var(--p3events-contain-desktop-margin);
  }
}
@media (min-width: 992px) {
  .p3-events-plugin .contain-lg {
    margin-right: var(--p3events-contain-margin);
    margin-left: var(--p3events-contain-margin);
  }
}
@media (min-width: 992px) and (min-width: 768px) {
  .p3-events-plugin .contain-lg {
    margin-right: var(--p3events-contain-tablet-portrait-margin);
    margin-left: var(--p3events-contain-tablet-portrait-margin);
  }
}
@media (min-width: 992px) and (min-width: 992px) {
  .p3-events-plugin .contain-lg {
    margin-right: var(--p3events-contain-tablet-landscape-margin);
    margin-left: var(--p3events-contain-tablet-landscape-margin);
  }
}
@media (min-width: 992px) and (min-width: 1200px) {
  .p3-events-plugin .contain-lg {
    margin-right: var(--p3events-contain-desktop-margin);
    margin-left: var(--p3events-contain-desktop-margin);
  }
}
.p3-events-plugin .contain-start {
  margin-left: var(--p3events-contain-margin);
}
@media (min-width: 768px) {
  .p3-events-plugin .contain-start {
    margin-left: var(--p3events-contain-tablet-portrait-margin);
  }
}
@media (min-width: 992px) {
  .p3-events-plugin .contain-start {
    margin-left: var(--p3events-contain-tablet-landscape-margin);
  }
}
@media (min-width: 1200px) {
  .p3-events-plugin .contain-start {
    margin-left: var(--p3events-contain-desktop-margin);
  }
}
.p3-events-plugin .contain-end {
  margin-right: var(--p3events-contain-margin);
}
@media (min-width: 768px) {
  .p3-events-plugin .contain-end {
    margin-right: var(--p3events-contain-tablet-portrait-margin);
  }
}
@media (min-width: 992px) {
  .p3-events-plugin .contain-end {
    margin-right: var(--p3events-contain-tablet-landscape-margin);
  }
}
@media (min-width: 1200px) {
  .p3-events-plugin .contain-end {
    margin-right: var(--p3events-contain-desktop-margin);
  }
}
.p3-events-plugin .contain-padding-start {
  padding-left: var(--p3events-contain-margin);
}
@media (min-width: 768px) {
  .p3-events-plugin .contain-padding-start {
    padding-left: var(--p3events-contain-tablet-portrait-margin);
  }
}
@media (min-width: 992px) {
  .p3-events-plugin .contain-padding-start {
    padding-left: var(--p3events-contain-tablet-landscape-margin);
  }
}
@media (min-width: 1200px) {
  .p3-events-plugin .contain-padding-start {
    padding-left: var(--p3events-contain-desktop-margin);
  }
}
.p3-events-plugin .contain-padding-end {
  padding-right: var(--p3events-contain-margin);
}
@media (min-width: 768px) {
  .p3-events-plugin .contain-padding-end {
    padding-right: var(--p3events-contain-tablet-portrait-margin);
  }
}
@media (min-width: 992px) {
  .p3-events-plugin .contain-padding-end {
    padding-right: var(--p3events-contain-tablet-landscape-margin);
  }
}
@media (min-width: 1200px) {
  .p3-events-plugin .contain-padding-end {
    padding-right: var(--p3events-contain-desktop-margin);
  }
}
.p3-events-plugin .contain-nested-fullwidth > .alignfull:not(.has-set-width) {
  padding-right: 0;
  padding-left: 0;
}
.p3-events-plugin .contain-nested-fullwidth > .alignfull:not(.has-set-width) > .inner {
  margin-right: var(--p3events-contain-margin);
  margin-left: var(--p3events-contain-margin);
  max-width: none;
  width: auto;
}
@media (min-width: 768px) {
  .p3-events-plugin .contain-nested-fullwidth > .alignfull:not(.has-set-width) > .inner {
    margin-right: var(--p3events-contain-tablet-portrait-margin);
    margin-left: var(--p3events-contain-tablet-portrait-margin);
  }
}
@media (min-width: 992px) {
  .p3-events-plugin .contain-nested-fullwidth > .alignfull:not(.has-set-width) > .inner {
    margin-right: var(--p3events-contain-tablet-landscape-margin);
    margin-left: var(--p3events-contain-tablet-landscape-margin);
  }
}
@media (min-width: 1200px) {
  .p3-events-plugin .contain-nested-fullwidth > .alignfull:not(.has-set-width) > .inner {
    margin-right: var(--p3events-contain-desktop-margin);
    margin-left: var(--p3events-contain-desktop-margin);
  }
}
.p3-events-plugin .contain-nested-fullwidth > .alignfull.has-set-width .set-width {
  margin-right: var(--p3events-contain-margin);
  margin-left: var(--p3events-contain-margin);
}
@media (min-width: 768px) {
  .p3-events-plugin .contain-nested-fullwidth > .alignfull.has-set-width .set-width {
    margin-right: var(--p3events-contain-tablet-portrait-margin);
    margin-left: var(--p3events-contain-tablet-portrait-margin);
  }
}
@media (min-width: 992px) {
  .p3-events-plugin .contain-nested-fullwidth > .alignfull.has-set-width .set-width {
    margin-right: var(--p3events-contain-tablet-landscape-margin);
    margin-left: var(--p3events-contain-tablet-landscape-margin);
  }
}
@media (min-width: 1200px) {
  .p3-events-plugin .contain-nested-fullwidth > .alignfull.has-set-width .set-width {
    margin-right: var(--p3events-contain-desktop-margin);
    margin-left: var(--p3events-contain-desktop-margin);
  }
}
.p3-events-plugin .cover {
  position: absolute;
  inset: 0;
  opacity: 0;
}
.p3-events-plugin .loader {
  position: absolute;
  inset: 0;
  display: none;
  background-color: rgba(255,255,255,0.75);
  border-radius: 3px;
  justify-content: center;
  align-items: center;
/*backdrop-filter blur(5px)*/
  animation: fadeIn var(--p3events-easing);
  animation-fill-mode: forwards;
  animation-duration: 1s;
}
.p3-events-plugin .loading > .loader {
  z-index: 100;
  display: flex;
}
/* Universal Styles */
html {
  scrollbar-gutter: stable;
  scroll-behavior: smooth;
}
.p3-events-plugin .p3-calendar i {
  font-family: 'Material Icons';
  font-weight: normal;
  font-style: normal;
  font-size: 1rem;
  line-height: 1;
  display: inline-block;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;
  vertical-align: -2px;
  text-rendering: optimizeLegibility;
  font-feature-settings: 'liga';
}
.p3-events-plugin .p3-calendar img {
  width: 100%;
  height: auto;
}
.p3-events-plugin .p3-calendar img.not-loaded:not(.placeholder) {
  opacity: 0;
}
.p3-events-plugin .p3-calendar img.placeholder.not-loaded {
  background: linear-gradient(45deg, var(--vn-color-canvas), var(--vn-color-primary), var(--vn-color-secondary));
  background-size: 500% 500%;
  animation: gradient 10s var(--vn-easing) infinite;
}
.p3-events-plugin .p3-calendar img.placeholder.not-loaded.loaded {
  animation: fadeIn var(--p3events-easing);
  animation-fill-mode: forwards;
  animation-duration: 1s;
  animation-delay: 0;
}
.p3-events-plugin .p3-calendar img.loaded {
  animation: fadeIn var(--p3events-easing);
  animation-fill-mode: forwards;
  animation-duration: 1s;
  animation-delay: 0;
}
.p3-events-plugin .p3-calendar .container > .inner {
  position: relative;
}
.p3-events-plugin .p3-calendar .glass {
  background: none;
  border-radius: var(--vn-border-radius);
}
@media print {
  @page {
    size: landscape;
    margin: 0;
  }
  .p3-events-plugin html,
  .p3-events-plugin body {
    height: 100dvh;
    overflow: hidden;
    margin: 0 !important;
    padding: 0 !important;
  }
  .p3-events-plugin #site-header,
  .p3-events-plugin #site-footer,
  .p3-events-plugin .event-popover-container {
    display: none;
  }
  .p3-events-plugin .p3-calendar {
    height: 100%;
    max-height: 100%;
    margin: 0;
    overflow: hidden;
    break-inside: avoid;
    page-break-inside: avoid;
  }
  .p3-events-plugin .calendar-events-view .calendar-nav,
  .p3-events-plugin .calendar-events-view .calendar-month-picker,
  .p3-events-plugin .calendar-events-view .calendar-month-picker i,
  .p3-events-plugin .calendar-events-view .calendar-heading a.no-underline,
  .p3-events-plugin .calendar-events-view .day-events .event-thumbnail {
    display: none;
  }
  .p3-events-plugin .calendar-events-view a {
    text-decoration: none !important;
  }
  .p3-events-plugin .calendar-events-view .calendar-heading {
    padding-bottom: 0 !important;
  }
  .p3-events-plugin .calendar-events-view .calendar-heading h1 {
    font-size: 1.5rem;
    line-height: 1;
    margin-bottom: 0;
  }
  .p3-events-plugin .calendar-events-view .calendar {
    background: transparent;
    border-right: 1px solid rgba(0,0,0,0.1);
    border-bottom: 1px solid rgba(0,0,0,0.1);
    grid-column-gap: 0;
    grid-row-gap: 0;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  .p3-events-plugin .calendar-events-view .calendar .day {
    background: transparent;
    border-top: 1px solid rgba(0,0,0,0.1);
    border-left: 1px solid rgba(0,0,0,0.1);
    opacity: 1 !important;
  }
  .p3-events-plugin .calendar-events-view .calendar .day.today {
    --primary: var(--body-font-color);
  }
  .p3-events-plugin .calendar-events-view .calendar .day.today:before,
  .p3-events-plugin .calendar-events-view .calendar .day.today:after {
    content: none !important;
  }
  .p3-events-plugin .calendar-events-view .calendar .day .day-label {
    font-size: 0.75rem;
    padding: 0 0.25rem;
  }
  .p3-events-plugin .calendar-events-view .calendar .day .day-label:before {
    opacity: 0.05;
  }
  .p3-events-plugin .calendar-events-view .calendar .day .day-events .event a:before {
    border-top: 1px solid var(--p3events-event-color, var(--primary));
    border-right: 1px solid var(--p3events-event-color, var(--primary));
    border-bottom: 1px solid var(--p3events-event-color, var(--primary));
    opacity: 0.15;
  }
  .p3-events-plugin .calendar-events-view .calendar .day .day-events .event a span.event-time {
    font-size: 0.5rem !important;
  }
  .p3-events-plugin .calendar-events-view .calendar .day .day-events .event a span.event-date {
    font-size: 0.75rem !important;
  }
}
.p3-events-plugin .missing-thumbnail {
  position: relative;
  display: inline-block;
}
.p3-events-plugin .missing-thumbnail img {
  border-radius: 50%;
}
.p3-events-plugin .missing-thumbnail:after {
  content: '?';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  font-size: 2em;
  text-shadow: 1px 1px 0 rgba(0,0,0,0.5);
  line-height: 48px;
  color: var(--p3events-color-canvas);
}
.p3-events-plugin .missing-element {
  position: relative;
  z-index: 9999;
  background-color: var(--p3events-color-canvas);
  border: 1px dashed var(--p3events-color-canvas-contrast);
  border-radius: 8px;
  color: var(--p3events-color-text-base);
  margin: 1rem;
  padding: 1rem;
}
.p3-events-plugin .missing-element:before {
  content: 'Missing Template';
  position: absolute;
  top: 0.15rem;
  left: 1rem;
  font-size: 0.75em;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--p3events-color-text-base);
  opacity: 0.25;
}
.p3-events-plugin .missing-element pre {
  margin-bottom: 0;
}
.p3-events-plugin .acf-map-container {
  border-top: none;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}
.p3-events-plugin .acf-map {
  width: 100%;
  height: var(--map-height, 400px);
}
.p3-events-plugin .acf-map-window {
  min-width: 180px;
  padding: 4px 2px 2px;
  font-size: 14px;
  line-height: 1.35;
}
.p3-events-plugin .acf-map-window-title {
  margin-bottom: 6px;
  color: #222;
  font-weight: 600;
}
.p3-events-plugin .acf-map-window-link {
  display: inline-flex;
  align-items: center;
  color: #007bff;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
}
.p3-events-plugin .acf-map-window-linkhover {
  color: #0056b3;
  text-decoration: underline;
}
.p3-events-plugin .gm-style .gm-style-iw-c {
  padding: 12px !important;
  border-radius: 8px !important;
}
.p3-events-plugin .gm-style .gm-style-iw-d {
  overflow: hidden !important;
}
.p3-events-plugin .venue-map-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.p3-events-plugin .venue-map-item {
  padding: 1rem;
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  background: #fff;
}
.p3-events-plugin .venue-map-title {
  margin-bottom: 0.35rem;
  font-weight: 600;
}
.p3-events-plugin .venue-map-address {
  margin-bottom: 0.5rem;
  color: #666;
  font-size: 0.95rem;
}
.p3-events-plugin .venue-map-directions {
  font-weight: 600;
}
.p3-events-plugin .modal .modal-variable-width {
  display: table;
  width: auto;
  min-width: 300px;
}
.p3-events-plugin .alignwide {
  padding-right: 1rem;
  padding-left: 1rem;
}
.p3-events-plugin .wp-core-block.container .container {
  max-width: none;
  padding: 0;
}
.p3-events-plugin .p3-events-shortcode .item {
  position: relative;
}
.p3-events-plugin .p3-events-shortcode .item .inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.p3-events-plugin .p3-events-shortcode .item .event-cover img {
  border-radius: var(--p3events-border-radius);
  max-width: 64px;
}
.p3-events-plugin #event-attendees-modal .event-attendee-avatar img {
  min-width: 40px;
}
.p3-events-plugin #manage-attendees-modal .modal-body > .row {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 1rem;
  margin-left: 0;
  margin-right: 0;
  padding-bottom: 1rem !important;
}
.p3-events-plugin #manage-attendees-modal .modal-body > .row > [class*='col-'] {
  max-width: none;
  padding-left: 0;
  padding-right: 0;
  margin-bottom: 0 !important;
}
@media (min-width: 768px) {
  .p3-events-plugin #manage-attendees-modal .modal-body > .row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (min-width: 992px) {
  .p3-events-plugin #manage-attendees-modal .modal-body > .row {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
.p3-events-plugin .attendee-details-modal .modal-body > .row {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 1rem;
  margin-left: 0;
  margin-right: 0;
}
.p3-events-plugin .attendee-details-modal .modal-body > .row > [class*='col-'] {
  max-width: none;
  padding-left: 0;
  padding-right: 0;
  margin-bottom: 0 !important;
}
@media (min-width: 768px) {
  .p3-events-plugin .attendee-details-modal .modal-body > .row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.p3-events-plugin .calendar-heading .calendar-nav a {
  display: block;
}
.p3-events-plugin .calendar-heading .calendar-nav a:hover {
  text-decoration: none;
}
.p3-events-plugin .calendar-heading .calendar-nav i {
  display: block;
  font-size: 3rem;
}
.p3-events-plugin .calendar-heading .calendar-month-picker {
  cursor: pointer;
  position: relative;
  display: inline-block;
  background-color: var(--p3events-month-picker-icon-bg);
  border: none;
  border-radius: 50%;
  font-size: 2rem;
  color: #fff;
  width: 2rem;
  height: 2rem;
  overflow: hidden;
}
.p3-events-plugin .calendar-heading .calendar-month-picker input {
  position: absolute;
  inset: 0;
  z-index: 200;
  width: 100%;
  opacity: 0;
}
.p3-events-plugin .calendar-heading .calendar-month-picker input::-webkit-calendar-picker-indicator {
  cursor: pointer;
}
.p3-events-plugin .calendar-heading .calendar-month-picker i {
  position: absolute;
  inset: 0;
  z-index: 100;
  text-align: center;
  font-size: 1.25rem;
  line-height: 2rem;
  width: 100%;
  height: 100%;
}
.p3-events-plugin .calendar {
  --p3-events-month-event-padding: 0.5rem;
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  grid-column-gap: 2px;
  grid-row-gap: 2px;
  margin: 0 0 3rem;
  padding: 2px 0;
}
.p3-events-plugin .calendar .day-heading {
  background-color: var(--p3events-month-day-heading-bg-color);
  color: var(--p3events-month-day-heading-text-color);
}
.p3-events-plugin .calendar .day {
  position: relative;
  background: rgba(0,0,0,0.05);
  min-height: 8rem;
  opacity: 0.333;
}
.p3-events-plugin .calendar .day.not-month {
  opacity: 0.2;
}
.p3-events-plugin .calendar .day.today {
  opacity: 1;
}
.p3-events-plugin .calendar .day.today:before,
.p3-events-plugin .calendar .day.today:after {
  content: '\\20';
  position: absolute;
  inset: 0;
}
.p3-events-plugin .calendar .day.today:before {
  box-shadow: inset 0 0 2rem currentColor;
  opacity: 0.1;
}
.p3-events-plugin .calendar .day.today:after {
  border: 1px solid currentColor;
  opacity: 0.25;
}
.p3-events-plugin .calendar .day.today ~ *:not(.not-month) {
  opacity: 1;
}
.p3-events-plugin .calendar .day.day-heading {
  opacity: 1;
}
.p3-events-plugin .calendar .day.day-heading .day-label {
  font-size: 0.86em;
  font-weight: 700;
  text-transform: uppercase;
}
.p3-events-plugin .calendar .day.day-0 {
  z-index: 1000;
}
.p3-events-plugin .calendar .day.day-1 {
  z-index: 900;
}
.p3-events-plugin .calendar .day.day-2 {
  z-index: 800;
}
.p3-events-plugin .calendar .day.day-3 {
  z-index: 700;
}
.p3-events-plugin .calendar .day.day-4 {
  z-index: 600;
}
.p3-events-plugin .calendar .day.day-5 {
  z-index: 500;
}
.p3-events-plugin .calendar .day.day-6 {
  z-index: 400;
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start.continues a {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.p3-events-plugin .calendar .day.day-0 .day-events .event.multiday-end > a {
  max-width: 100%;
}
.p3-events-plugin .calendar .day.day-0 .day-events .event.multiday-end > a,
.p3-events-plugin .calendar .day.day-0 .day-events .event.multiday > a {
  opacity: 1;
}
.p3-events-plugin .calendar .day.day-0 .day-events .event.multiday-end > a span,
.p3-events-plugin .calendar .day.day-0 .day-events .event.multiday > a span {
  opacity: 1;
  overflow: hidden;
}
.p3-events-plugin .calendar .day.day-6 .day-events .event.multiday-start.continues > a {
  max-width: 100%;
}
.p3-events-plugin .calendar .day.day-6 .day-events .event.multiday-start {
  padding-right: 0;
}
.p3-events-plugin .calendar .day.day-6 .day-events .event.multiday-start > a {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.p3-events-plugin .calendar .day > * {
  position: relative;
}
.p3-events-plugin .calendar .day .day-label,
.p3-events-plugin .calendar .day .day-events {
  position: relative;
  z-index: 10;
}
.p3-events-plugin .calendar .day .day-label {
  user-select: none;
  font-size: 0.86em;
  padding: 0.25rem var(--p3-events-month-event-padding);
}
.p3-events-plugin .calendar .day .day-label:before {
  content: '\\20';
  position: absolute;
  inset: 0;
  background-color: currentColor;
  opacity: 0.1;
}
.p3-events-plugin .calendar .day .day-events {
  list-style: none;
  margin: 0;
  padding: 0.5rem 0;
}
.p3-events-plugin .calendar .day .day-events .event {
  font-size: 0.86em;
  color: #fff;
  width: 100%;
  padding-right: var(--p3-events-month-event-padding);
  padding-left: var(--p3-events-month-event-padding);
}
.p3-events-plugin .calendar .day .day-events .event:not(:last-child) {
  margin-bottom: 0.25rem;
}
.p3-events-plugin .calendar .day .day-events .event.multiday > a.duration-1 {
  width: calc((100% * 1) + (var(--p3-events-month-event-padding) * 0) - var(--p3-events-month-event-padding) + (2px * 0));
}
.p3-events-plugin .calendar .day .day-events .event.multiday > a.duration-2 {
  width: calc((100% * 2) + (var(--p3-events-month-event-padding) * 2) - var(--p3-events-month-event-padding) + (2px * 1));
}
.p3-events-plugin .calendar .day .day-events .event.multiday > a.duration-3 {
  width: calc((100% * 3) + (var(--p3-events-month-event-padding) * 4) - var(--p3-events-month-event-padding) + (2px * 2));
}
.p3-events-plugin .calendar .day .day-events .event.multiday > a.duration-4 {
  width: calc((100% * 4) + (var(--p3-events-month-event-padding) * 6) - var(--p3-events-month-event-padding) + (2px * 3));
}
.p3-events-plugin .calendar .day .day-events .event.multiday > a.duration-5 {
  width: calc((100% * 5) + (var(--p3-events-month-event-padding) * 8) - var(--p3-events-month-event-padding) + (2px * 4));
}
.p3-events-plugin .calendar .day .day-events .event.multiday > a.duration-6 {
  width: calc((100% * 6) + (var(--p3-events-month-event-padding) * 10) - var(--p3-events-month-event-padding) + (2px * 5));
}
.p3-events-plugin .calendar .day .day-events .event.multiday > a.duration-7 {
  width: calc((100% * 7) + (var(--p3-events-month-event-padding) * 12) - var(--p3-events-month-event-padding) + (2px * 6));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start > a.duration-1 {
  width: calc((100% * 1) + (var(--p3-events-month-event-padding) * 0) + (2px * 0));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start > a.duration-2 {
  width: calc((100% * 2) + (var(--p3-events-month-event-padding) * 2) + (2px * 1));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start > a.duration-3 {
  width: calc((100% * 3) + (var(--p3-events-month-event-padding) * 4) + (2px * 2));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start > a.duration-4 {
  width: calc((100% * 4) + (var(--p3-events-month-event-padding) * 6) + (2px * 3));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start > a.duration-5 {
  width: calc((100% * 5) + (var(--p3-events-month-event-padding) * 8) + (2px * 4));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start > a.duration-6 {
  width: calc((100% * 6) + (var(--p3-events-month-event-padding) * 10) + (2px * 5));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start > a.duration-7 {
  width: calc((100% * 7) + (var(--p3-events-month-event-padding) * 12) + (2px * 6));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start.continues > a.duration-1 {
  width: calc((100% * 1) + (var(--p3-events-month-event-padding) * 1) + (2px * 0));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start.continues > a.duration-2 {
  width: calc((100% * 2) + (var(--p3-events-month-event-padding) * 3) + (2px * 1));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start.continues > a.duration-3 {
  width: calc((100% * 3) + (var(--p3-events-month-event-padding) * 5) + (2px * 2));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start.continues > a.duration-4 {
  width: calc((100% * 4) + (var(--p3-events-month-event-padding) * 7) + (2px * 3));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start.continues > a.duration-5 {
  width: calc((100% * 5) + (var(--p3-events-month-event-padding) * 9) + (2px * 4));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start.continues > a.duration-6 {
  width: calc((100% * 6) + (var(--p3-events-month-event-padding) * 11) + (2px * 5));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start.continues > a.duration-7 {
  width: calc((100% * 7) + (var(--p3-events-month-event-padding) * 13) + (2px * 6));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start.multiday > a.duration-1 {
  width: calc((100% * 1) + (var(--p3-events-month-event-padding) * 0) + (2px * 0));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start.multiday > a.duration-2 {
  width: calc((100% * 2) + (var(--p3-events-month-event-padding) * 1) + (2px * 1));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start.multiday > a.duration-3 {
  width: calc((100% * 3) + (var(--p3-events-month-event-padding) * 2) + (2px * 2));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start.multiday > a.duration-4 {
  width: calc((100% * 4) + (var(--p3-events-month-event-padding) * 3) + (2px * 3));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start.multiday > a.duration-5 {
  width: calc((100% * 5) + (var(--p3-events-month-event-padding) * 4) + (2px * 4));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start.multiday > a.duration-6 {
  width: calc((100% * 6) + (var(--p3-events-month-event-padding) * 5) + (2px * 5));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start.multiday > a.duration-7 {
  width: calc((100% * 7) + (var(--p3-events-month-event-padding) * 6) + (2px * 6));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start.multiday.continues > a.duration-1 {
  width: calc((100% * 1) + (var(--p3-events-month-event-padding) * 1) + (2px * 0));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start.multiday.continues > a.duration-2 {
  width: calc((100% * 2) + (var(--p3-events-month-event-padding) * 2) + (2px * 1));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start.multiday.continues > a.duration-3 {
  width: calc((100% * 3) + (var(--p3-events-month-event-padding) * 3) + (2px * 2));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start.multiday.continues > a.duration-4 {
  width: calc((100% * 4) + (var(--p3-events-month-event-padding) * 4) + (2px * 3));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start.multiday.continues > a.duration-5 {
  width: calc((100% * 5) + (var(--p3-events-month-event-padding) * 5) + (2px * 4));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start.multiday.continues > a.duration-6 {
  width: calc((100% * 6) + (var(--p3-events-month-event-padding) * 6) + (2px * 5));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-start.multiday.continues > a.duration-7 {
  width: calc((100% * 7) + (var(--p3-events-month-event-padding) * 7) + (2px * 6));
}
.p3-events-plugin .calendar .day .day-events .event.multiday-end,
.p3-events-plugin .calendar .day .day-events .event.multiday {
  padding-left: 0;
}
.p3-events-plugin .calendar .day .day-events .event.multiday-end > a,
.p3-events-plugin .calendar .day .day-events .event.multiday > a {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  opacity: 0;
}
.p3-events-plugin .calendar .day .day-events .event.multiday-end > a span,
.p3-events-plugin .calendar .day .day-events .event.multiday > a span {
  opacity: 0;
}
.p3-events-plugin .calendar .day .day-events .event a {
  position: relative;
  display: block;
  background-color: #fff;
  border-left: 3px solid var(--p3events-event-color, var(--primary));
  color: #000;
  padding: 0.25rem var(--p3-events-month-event-padding);
  transition: color var(--p3events-transition);
}
.p3-events-plugin .calendar .day .day-events .event a:hover,
.p3-events-plugin .calendar .day .day-events .event a.hover {
  text-decoration: none;
}
.p3-events-plugin .calendar .day .day-events .event a:hover:before,
.p3-events-plugin .calendar .day .day-events .event a.hover:before {
  opacity: 0.25;
}
.p3-events-plugin .calendar .day .day-events .event a:before {
  content: '\\20';
  position: absolute;
  inset: 0;
  background-color: var(--p3events-event-color, var(--primary));
  width: 100%;
  height: 100%;
  opacity: 0.1;
  transition: opacity var(--p3events-transition);
}
.p3-events-plugin .calendar .day .day-events .event a span {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.p3-events-plugin .calendar .day .day-events .event a .event-time {
  font-size: 0.75em;
  opacity: 0.85;
}
.p3-events-plugin .calendar .day .day-events .event .event-thumbnail {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.p3-events-plugin .calendar .day .day-events .event .event-thumbnail img {
  border-radius: var(--p3events-border-radius);
  max-width: 4rem;
  width: 100%;
}
.p3-events-plugin .event-popover {
  pointer-events: none;
  position: fixed;
  z-index: 1000;
  border-radius: var(--p3events-border-radius);
  min-width: 220px;
  max-width: 400px;
  padding: 0;
  opacity: 0;
  visibility: hidden;
  overflow-y: auto;
  transform: translateY(4px);
  transition: opacity var(--p3events-transition), transform var(--p3events-transition), visibility 0s linear var(--p3events-transition);
}
.p3-events-plugin .event-popover[data-state="open"],
.p3-events-plugin .event-popover[data-state="closing"] {
  visibility: visible;
}
.p3-events-plugin .event-popover[data-state="open"] {
  pointer-events: auto;
  opacity: 1;
  transform: translateY(0);
  transition: opacity var(--p3events-transition), transform var(--p3events-transition), visibility 0s linear 0s;
}
.p3-events-plugin .event-popover[data-state="closing"] {
  pointer-events: none;
  opacity: 0;
  transform: translateY(4px);
}
.p3-events-plugin .event-popover[data-state="closed"] {
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transform: translateY(4px);
}
.p3-events-plugin .event-popover > .inner {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: var(--p3events-border-radius);
  box-shadow: 0 8px 20px rgba(0,0,0,0.12);
  padding: 1rem;
}
.p3-events-plugin .event-popover > .inner .event-thumbnail img {
  display: block;
  max-width: 100%;
  width: auto;
  height: auto;
  margin: 0 auto;
}
.p3-events-plugin #event-attendees-modal .event-attendee-avatar-public img {
  width: 36px;
  min-width: 0;
}
.p3-events-plugin #event-attendees-modal .event-attendee-question-label {
  display: block;
  max-width: 8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.p3-events-plugin .attendee-questions-modal.has-multiple .hide-for-single {
  display: block;
}
.p3-events-plugin .attendee-questions-modal .hide-for-single {
  display: none;
}
.p3-events-plugin .attendee-questions-modal .carousel-item .card-header {
  display: flex;
  align-items: center;
  gap: 4px;
}
.p3-events-plugin .event-attendee-questions .carousel-item.active:first-child .control-prev,
.p3-events-plugin .event-attendee-questions .carousel-item.carousel-item-right:first-child .control-prev {
  display: none;
}
.p3-events-plugin .event-attendee-questions .carousel-item.active:last-child .control-next,
.p3-events-plugin .event-attendee-questions .carousel-item.carousel-item-left:last-child .control-next {
  display: none;
}
.p3-events-plugin .event-attendee-questions .carousel-indicators {
  justify-content: start;
}
.p3-events-plugin .event-attendee-questions .carousel-indicators > li {
  background-color: var(--primary);
  border: none;
  text-indent: 0;
  width: auto;
  height: auto;
}
`, "",{"version":3,"sources":["webpack://./resources/stylus/app.styl","webpack://./resources/stylus/_mixins/animations.styl","webpack://./resources/stylus/_variables.styl","webpack://./resources/stylus/_utilities.styl","webpack://./resources/stylus/_mixins/spacing.styl","webpack://./resources/stylus/_mixins/viewports.styl","webpack://./resources/stylus/_universal.styl","webpack://./resources/stylus/_global.styl","webpack://./resources/stylus/_print.styl","webpack://./resources/stylus/_elements/_missing.styl","webpack://./resources/stylus/_elements/map.styl","webpack://./resources/stylus/_elements/modal.styl","webpack://./resources/stylus/_vendors/gutenberg.styl","webpack://./resources/stylus/views/_shortcodes/events/upcoming.styl","webpack://./resources/stylus/views/events/attendees.styl","webpack://./resources/stylus/views/events/calendar.styl","webpack://./resources/stylus/views/events/public-attendees.styl","webpack://./resources/stylus/views/events/tickets.styl"],"names":[],"mappings":"AAAA,yBAAA;ACsCA;EACI;IACI,4CAAU;EDpChB;ECuCE;IACI,4CAAU;EDrChB;ECuCE;IACI,yCAAU;EDrChB;ECuCE;IACI,4CAAU;EDrChB;ECwCE;IACI,4CAAU;EDtChB;ECwCE;IACI,yCAAU;EDtChB;ECwCE;IACI,2CAAU;EDtChB;ECyCE;IACI,4CAAU;EDvChB;AACF;ACYA;EACI;IACI,4CAAU;EDVhB;ECaE;IACI,4CAAU;EDXhB;ECaE;IACI,yCAAU;EDXhB;ECaE;IACI,4CAAU;EDXhB;ECcE;IACI,4CAAU;EDZhB;ECcE;IACI,yCAAU;EDZhB;ECcE;IACI,2CAAU;EDZhB;ECeE;IACI,4CAAU;EDbhB;AACF;ACdA;EACI;IACI,4CAAU;EDgBhB;ECbE;IACI,4CAAU;EDehB;ECbE;IACI,yCAAU;EDehB;ECbE;IACI,4CAAU;EDehB;ECZE;IACI,4CAAU;EDchB;ECZE;IACI,yCAAU;EDchB;ECZE;IACI,2CAAU;EDchB;ECXE;IACI,4CAAU;EDahB;AACF;ACxCA;EACI;IACI,4CAAU;ED0ChB;ECvCE;IACI,4CAAU;EDyChB;ECvCE;IACI,yCAAU;EDyChB;ECvCE;IACI,4CAAU;EDyChB;ECtCE;IACI,4CAAU;EDwChB;ECtCE;IACI,yCAAU;EDwChB;ECtCE;IACI,2CAAU;EDwChB;ECrCE;IACI,4CAAU;EDuChB;AACF;ACrCA;EACI;IACI,mDAAW;IACX,UAAS;EDuCf;ECrCE;IACI,+DAAW;IACX,UAAS;EDuCf;ECrCE;IACI,mDAAW;IACX,UAAS;EDuCf;AACF;ACnDA;EACI;IACI,mDAAW;IACX,UAAS;EDqDf;ECnDE;IACI,+DAAW;IACX,UAAS;EDqDf;ECnDE;IACI,mDAAW;IACX,UAAS;EDqDf;AACF;ACjEA;EACI;IACI,mDAAW;IACX,UAAS;EDmEf;ECjEE;IACI,+DAAW;IACX,UAAS;EDmEf;ECjEE;IACI,mDAAW;IACX,UAAS;EDmEf;AACF;AC/EA;EACI;IACI,mDAAW;IACX,UAAS;EDiFf;EC/EE;IACI,+DAAW;IACX,UAAS;EDiFf;EC/EE;IACI,mDAAW;IACX,UAAS;EDiFf;AACF;AC9EA;EACI;IACI,UAAQ;EDgFd;EC9EE;IACI,UAAQ;EDgFd;AACF;ACtFA;EACI;IACI,UAAQ;EDwFd;ECtFE;IACI,UAAQ;EDwFd;AACF;AC9FA;EACI;IACI,UAAQ;EDgGd;EC9FE;IACI,UAAQ;EDgGd;AACF;ACtGA;EACI;IACI,UAAQ;EDwGd;ECtGE;IACI,UAAQ;EDwGd;AACF;ACtGA;EACI;IACI,UAAQ;EDwGd;ECtGE;IACI,UAAQ;EDwGd;AACF;AC9GA;EACI;IACI,UAAQ;EDgHd;EC9GE;IACI,UAAQ;EDgHd;AACF;ACtHA;EACI;IACI,UAAQ;EDwHd;ECtHE;IACI,UAAQ;EDwHd;AACF;AC9HA;EACI;IACI,UAAQ;EDgId;EC9HE;IACI,UAAQ;EDgId;AACF;AC9HA;EACI;IACI,qBAAU;EDgIhB;EC9HE;IACI,mBAAU;EDgIhB;AACF;ACtIA;EACI;IACI,qBAAU;EDwIhB;ECtIE;IACI,mBAAU;EDwIhB;AACF;AC9IA;EACI;IACI,qBAAU;EDgJhB;EC9IE;IACI,mBAAU;EDgJhB;AACF;ACtJA;EACI;IACI,qBAAU;EDwJhB;ECtJE;IACI,mBAAU;EDwJhB;AACF;ACtJA;EACI;IACI,gCAAU;IACV,UAAQ;EDwJd;ECtJE;IACI,kCAAU;IACV,UAAQ;EDwJd;AACF;AChKA;EACI;IACI,gCAAU;IACV,UAAQ;EDkKd;EChKE;IACI,kCAAU;IACV,UAAQ;EDkKd;AACF;AC1KA;EACI;IACI,gCAAU;IACV,UAAQ;ED4Kd;EC1KE;IACI,kCAAU;IACV,UAAQ;ED4Kd;AACF;ACpLA;EACI;IACI,gCAAU;IACV,UAAQ;EDsLd;ECpLE;IACI,kCAAU;IACV,UAAQ;EDsLd;AACF;ACpLA;EACI;IACI,uBAAU;EDsLhB;ECpLE;IACI,yBAAU;EDsLhB;AACF;AC5LA;EACI;IACI,uBAAU;ED8LhB;EC5LE;IACI,yBAAU;ED8LhB;AACF;ACpMA;EACI;IACI,uBAAU;EDsMhB;ECpME;IACI,yBAAU;EDsMhB;AACF;AC5MA;EACI;IACI,uBAAU;ED8MhB;EC5ME;IACI,yBAAU;ED8MhB;AACF;AC5MA;EACI;IACI,8CAAU;ED8MhB;EC5ME;IACI,gDAAU;ED8MhB;EC5ME;IACI,8CAAU;ED8MhB;AACF;ACvNA;EACI;IACI,8CAAU;EDyNhB;ECvNE;IACI,gDAAU;EDyNhB;ECvNE;IACI,8CAAU;EDyNhB;AACF;AClOA;EACI;IACI,8CAAU;EDoOhB;EClOE;IACI,gDAAU;EDoOhB;EClOE;IACI,8CAAU;EDoOhB;AACF;AC7OA;EACI;IACI,8CAAU;ED+OhB;EC7OE;IACI,gDAAU;ED+OhB;EC7OE;IACI,8CAAU;ED+OhB;AACF;AC7OA;EACI;IACI,0BAAqB;ED+O3B;EC7OE;IACI,6BAAqB;ED+O3B;EC7OE;IACI,0BAAqB;ED+O3B;AACF;ACxPA;EACI;IACI,0BAAqB;ED0P3B;ECxPE;IACI,6BAAqB;ED0P3B;ECxPE;IACI,0BAAqB;ED0P3B;AACF;ACnQA;EACI;IACI,0BAAqB;EDqQ3B;ECnQE;IACI,6BAAqB;EDqQ3B;ECnQE;IACI,0BAAqB;EDqQ3B;AACF;AC9QA;EACI;IACI,0BAAqB;EDgR3B;EC9QE;IACI,6BAAqB;EDgR3B;EC9QE;IACI,0BAAqB;EDgR3B;AACF;AEhaA;EAMI,gCAA4B;EAC5B,4BAAwB;EACxB,4BAAwB;EAGxB,iCAA0B;EAC1B,mCAA4B;EAC5B,gCAAyB;EACzB,8BAA0B;EAC1B,gCAAyB;EACzB,uCAAgC;EAChC,wCAAiC;EACjC,iCAA0B;EAC1B,iCAA0B;EAC1B,+BAAwB;EAGxB,+CAAmC;EACnC,0CAAmC;EACnC,iDAA0C;EAC1C,yDAAkD;EAClD,wEAAiD;EACjD,2DAAoC;EACpC,iEAA4B;EAC5B,+DAAgC;EAChC,+BAA2B;EAG3B,qCAA+B;EAC/B,2DAAgC;EAChC,2DAAgC;EAChC,2CAAwC;EACxC,4CAAwC;EACxC,6CAAsC;EACtC,6CAAsC;EACtC,iEAAsC;EACtC,iEAAsC;EACtC,kDAA8C;EAC9C,iDAA8C;EAC9C,6CAAuB;EAGvB,iDAAmB;EACnB,mCAA8B;EAC9B,+EAAuB;EACvB,8BAA0B;EAC1B,+DAA2B;EAC3B,+BAA2B;EAG3B,8CAAuB;EACvB,sDAA6B;EAC7B,4DAA8B;EAG9B,wDAA6B;EAC7B,mCAA2B;EAC3B,2BAAuB;EACvB,4DAA6B;EAS7B,+BAA2B;EAC3B,4DAA2C;EAC3C,0FAA4C;EAC5C,qCAAmC;EAGnC,+DAA4B;EAC5B,0CAAuC;EACvC,qCAAiC;EACjC,mCAA0B;EAC1B,0CAAoC;EACpC,sEAA0C;EAC1C,mEAA+B;EAC/B,oCAAiC;EAGjC,+BAA0B;EAG1B,wFAAqC;EACrC,0EAA8B;EAC9B,uGAA2C;EAC3C,yFAAoC;EACpC,sEAAkC;EAClC,wDAA2B;EAC3B,yFAAwC;EACxC,2EAAiC;EAGjC,qCAAiC;EAGjC,2DAAgC;EAChC,8DAA2B;EAC3B,8DAA2B;EAC3B,8DAA2B;EAC3B,8DAA2B;EAC3B,8DAA2B;EAC3B,8DAA2B;EAC3B,gCAAyB;EACzB,6BAAyB;EACzB,gCAAyB;EACzB,+BAAyB;EACzB,gCAAyB;EACzB,gCAAyB;EACzB,oCAAgC;EAChC,uCAAgC;EAChC,sCAAgC;EAChC,uCAAgC;EAChC,uCAAgC;EAChC,oCAAgC;EAChC,8BAA2B;EAC3B,8BAA2B;EAC3B,8BAA2B;EAC3B,8BAA2B;EAC3B,8BAA2B;EAC3B,8BAA2B;EAC3B,yDAA0B;EAC1B,yDAA0B;EAC1B,6DAA0B;EAC1B,yDAA0B;EAC1B,6DAA0B;EAC1B,yDAA0B;EAC1B,uCAA8B;EAC9B,kCAA8B;EAC9B,kCAA8B;EAC9B,kCAA8B;EAC9B,kCAA8B;EAC9B,uCAA8B;EAC9B,+DAAiC;EACjC,oCAAiC;EACjC,oCAAiC;EACjC,+DAAiC;EACjC,+DAAiC;EACjC,+DAAiC;EAGjC,mDAAiC;EACjC,yDAAuC;EACvC,6CAAyC;AF6X7C;AGjhBI;ECHA,4CAAa;EACb,2CAAY;AJuhBhB;AKjgB2B;EAAA;IDnBnB,4DAAa;IACb,2DAAY;EJwhBlB;AACF;AKjgB2B;EAAA;IDrBnB,6DAAa;IACb,4DAAY;EJ0hBlB;AACF;AKjgB4B;EAAA;IDvBpB,oDAAa;IACb,mDAAY;EJ4hBlB;AACF;AGpiBI;ECkCA,6CAAc;EACd,4CAAa;AJqgBjB;AKvhB2B;EAAA;IDqBnB,6DAAc;IACd,4DAAa;EJsgBnB;AACF;AKvhB2B;EAAA;IDmBnB,8DAAc;IACd,6DAAa;EJwgBnB;AACF;AKvhB4B;EAAA;IDiBpB,qDAAc;IACd,oDAAa;EJ0gBnB;AACF;AK9jB2B;EAAA;IDFvB,4CAAa;IACb,2CAAY;EJokBd;AACF;AK/iB2B;EAAA;IDnBnB,4DAAa;IACb,2DAAY;EJskBlB;AACF;AK/iB2B;EAAA;IDrBnB,6DAAa;IACb,4DAAY;EJwkBlB;AACF;AK/iB4B;EAAA;IDvBpB,oDAAa;IACb,mDAAY;EJ0kBlB;AACF;AKjlB2B;EAAA;IDPvB,4CAAa;IACb,2CAAY;EJ4lBd;AACF;AKvkB2B;EAAA;IDnBnB,4DAAa;IACb,2DAAY;EJ8lBlB;AACF;AKvkB2B;EAAA;IDrBnB,6DAAa;IACb,4DAAY;EJgmBlB;AACF;AKvkB4B;EAAA;IDvBpB,oDAAa;IACb,mDAAY;EJkmBlB;AACF;AKzmB2B;EAAA;IDiCvB,6CAAc;IACd,4CAAa;EJ4kBf;AACF;AK/lB2B;EAAA;IDqBnB,6DAAc;IACd,4DAAa;EJ8kBnB;AACF;AK/lB2B;EAAA;IDmBnB,8DAAc;IACd,6DAAa;EJglBnB;AACF;AK/lB4B;EAAA;IDiBpB,qDAAc;IACd,oDAAa;EJklBnB;AACF;AGlnBQ;ECtBJ,4CAAa;EACb,2CAAY;AJ2oBhB;AKrnB2B;EAAA;IDnBnB,4DAAa;IACb,2DAAY;EJ4oBlB;AACF;AKrnB2B;EAAA;IDrBnB,6DAAa;IACb,4DAAY;EJ8oBlB;AACF;AKrnB4B;EAAA;IDvBpB,oDAAa;IACb,mDAAY;EJgpBlB;AACF;AKvpB2B;EFoBf;IC3BR,4CAAa;IACb,2CAAY;EJkqBd;AACF;AK7oB2B;EFIf;ICvBJ,4DAAa;IACb,2DAAY;EJoqBlB;AACF;AK7oB2B;EFFf;ICnBJ,6DAAa;IACb,4DAAY;EJsqBlB;AACF;AK7oB4B;EFRhB;ICfJ,oDAAa;IACb,mDAAY;EJwqBlB;AACF;AK/qB2B;EFyBf;ICQR,6CAAc;IACd,4CAAa;EJkpBf;AACF;AKrqB2B;EFSf;ICYJ,6DAAc;IACd,4DAAa;EJopBnB;AACF;AKrqB2B;EFGf;ICgBJ,8DAAc;IACd,6DAAa;EJspBnB;AACF;AKrqB4B;EFHhB;ICoBJ,qDAAc;IACd,oDAAa;EJwpBnB;AACF;AKjrB2B;EAAA;ID7BvB,4CAAa;IACb,2CAAY;EJktBd;AACF;AK7rB2B;EAAA;IDnBnB,4DAAa;IACb,2DAAY;EJotBlB;AACF;AK7rB2B;EAAA;IDrBnB,6DAAa;IACb,4DAAY;EJstBlB;AACF;AK7rB4B;EAAA;IDvBpB,oDAAa;IACb,mDAAY;EJwtBlB;AACF;AG/rBI;ECvBA,2CAAY;AJytBhB;AKltB2B;EAAA;IDJnB,2DAAY;EJ0tBlB;AACF;AKjtB2B;EAAA;IDPnB,4DAAY;EJ4tBlB;AACF;AKhtB4B;EAAA;IDVpB,mDAAY;EJ8tBlB;AACF;AG9sBI;ECdA,4CAAa;AJ+tBjB;AKpuB2B;EAAA;IDQnB,4DAAa;EJguBnB;AACF;AKnuB2B;EAAA;IDKnB,6DAAa;EJkuBnB;AACF;AKluB4B;EAAA;IDEpB,oDAAa;EJouBnB;AACF;AG7tBI;ECWA,4CAAa;AJqtBjB;AKtvB2B;EAAA;IDoCnB,4DAAa;EJstBnB;AACF;AKrvB2B;EAAA;IDiCnB,6DAAa;EJwtBnB;AACF;AKpvB4B;EAAA;ID8BpB,oDAAa;EJ0tBnB;AACF;AG5uBI;ECoBA,6CAAc;AJ2tBlB;AKxwB2B;EAAA;IDgDnB,6DAAc;EJ4tBpB;AACF;AKvwB2B;EAAA;ID6CnB,8DAAc;EJ8tBpB;AACF;AKtwB4B;EAAA;ID0CpB,qDAAc;EJguBpB;AACF;AG1vBQ;EACI,gBAAc;EACd,eAAa;AH4vBzB;AG1vBY;ECxDR,4CAAa;EACb,2CAAY;EDyDA,eAAU;EACV,WAAM;AH6vBtB;AKjyB2B;EAAA;IDnBnB,4DAAa;IACb,2DAAY;EJwzBlB;AACF;AKjyB2B;EAAA;IDrBnB,6DAAa;IACb,4DAAY;EJ0zBlB;AACF;AKjyB4B;EAAA;IDvBpB,oDAAa;IACb,mDAAY;EJ4zBlB;AACF;AG5wBY;EC9DR,4CAAa;EACb,2CAAY;AJ60BhB;AKvzB2B;EAAA;IDnBnB,4DAAa;IACb,2DAAY;EJ80BlB;AACF;AKvzB2B;EAAA;IDrBnB,6DAAa;IACb,4DAAY;EJg1BlB;AACF;AKvzB4B;EAAA;IDvBpB,oDAAa;IACb,mDAAY;EJk1BlB;AACF;AG/xBI;EACI,kBAAS;EACT,QAAM;EACN,UAAQ;AHiyBhB;AG7xBI;EACI,kBAAS;EACT,QAAM;EACN,aAAQ;EACR,wCAAiB;EACjB,kBAAc;EACd,uBAAgB;EAChB,mBAAY;AACZ,4BAAA;EFhFJ,wCAAU;EACV,6BAAoB;EACpB,sBAAmB;ADg3BvB;AG9xBQ;EACI,YAAQ;EACR,aAAQ;AHgyBpB;AAl3BA,qBAAA;AMLA;EACI,wBAAiB;EACjB,uBAAgB;AN03BpB;AO33BI;EACI,6BAAY;EACZ,mBAAY;EACZ,kBAAW;EACX,eAAU;EACV,cAAY;EACZ,qBAAQ;EACR,oBAAe;EACf,sBAAe;EACf,iBAAU;EACV,mBAAY;EACZ,cAAU;EACV,oBAAe;EACf,kCAAe;EACf,6BAAsB;AP63B9B;AO33BI;EACI,WAAM;EACN,YAAO;AP63Bf;AO33BQ;EACI,UAAQ;AP63BpB;AO33BQ;EACI,8GAAW;EACX,0BAAgB;EAChB,iDAAU;AP63BtB;AO33BY;ENNR,wCAAU;EACV,6BAAoB;EACpB,sBAAmB;EACnB,kBAAgB;ADo4BpB;AO93BQ;ENTJ,wCAAU;EACV,6BAAoB;EACpB,sBAAmB;EACnB,kBAAgB;AD04BpB;AOh4BQ;EACI,kBAAS;APk4BrB;AOh4BI;EACI,gBAAW;EACX,sCAAc;APk4BtB;AQ36BO;EACH;IACI,eAAK;IACL,SAAO;ER66Bb;EQ36BE;;IACI,cAAO;IACP,gBAAS;IACT,oBAAO;IACP,qBAAQ;ER86Bd;EQ36BE;;;IACI,aAAQ;ER+6Bd;EQ76BE;IACI,YAAO;IACP,gBAAW;IACX,SAAO;IACP,gBAAS;IACT,mBAAa;IACb,wBAAkB;ER+6BxB;EQ56BM;;;;;IAKI,aAAQ;ER86BlB;EQ56BM;IACI,gCAAgB;ER86B1B;EQ56BM;IACI,4BAAe;ER86BzB;EQ56BU;IACI,iBAAU;IACV,cAAY;IACZ,gBAAc;ER86B5B;EQ56BM;IACI,uBAAW;IACX,uCAAa;IACb,wCAAc;IACd,kBAAgB;IAChB,eAAa;IACb,4CAA2B;IAC3B,oCAAmB;ER86B7B;EQ56BU;IACI,uBAAW;IACX,qCAAW;IACX,sCAAY;IACZ,qBAAQ;ER86BtB;EQ56Bc;IACI,iCAAU;ER86B5B;EQ56BkB;;IACI,wBAAQ;ER+6B9B;EQ76Bc;IACI,kBAAU;IACV,kBAAQ;ER+6B1B;EQ76BkB;IACI,aAAQ;ER+6B9B;EQ16B0B;IACI,iEAAW;IACX,mEAAa;IACb,oEAAc;IACd,aAAQ;ER46BtC;EQ16B0B;IACI,4BAAU;ER46BxC;EQ16B0B;IACI,6BAAU;ER46BxC;AACF;AShgCA;EACI,kBAAS;EACT,qBAAQ;ATkgCZ;AShgCI;EACI,kBAAc;ATkgCtB;AShgCI;EACI,YAAQ;EACR,kBAAS;EACT,MAAI;EACJ,QAAM;EACN,SAAO;EACP,OAAK;EACL,cAAU;EACV,sCAAY;EACZ,iBAAY;EACZ,mCAAM;ATkgCd;AShgCA;EACI,kBAAS;EACT,aAAQ;EACR,8CAAiB;EACjB,wDAAO;EACP,kBAAc;EACd,sCAAM;EACN,YAAO;EACP,aAAQ;ATkgCZ;AShgCI;EACI,2BAAQ;EACR,kBAAS;EACT,YAAI;EACJ,UAAK;EACL,iBAAU;EACV,gBAAY;EACZ,yBAAe;EACf,sCAAM;EACN,aAAQ;ATkgChB;AShgCI;EACI,gBAAc;ATkgCtB;AU3iCA;EACI,gBAAW;EACX,0BAAwB;EACxB,yBAAuB;AV6iC3B;AU3iCA;EACI,WAAM;EACN,gCAAO;AV6iCX;AU3iCA;EACI,gBAAU;EACV,oBAAQ;EACR,eAAU;EACV,iBAAY;AV6iChB;AU1iCA;EACI,kBAAc;EACd,WAAM;EACN,gBAAY;AV4iChB;AUziCA;EACI,oBAAQ;EACR,mBAAY;EACZ,cAAM;EACN,eAAU;EACV,gBAAY;EACZ,qBAAgB;AV2iCpB;AUxiCA;EACI,cAAM;EACN,0BAAgB;AV0iCpB;AUxiCA;EACI,wBAAQ;EACR,6BAAc;AV0iClB;AUviCA;EACI,2BAAS;AVyiCb;AUviCA;EACI,aAAQ;EACR,sBAAe;EACf,SAAI;AVyiCR;AUtiCA;EACI,aAAQ;EACR,yBAAO;EACP,qBAAc;EACd,gBAAW;AVwiCf;AUriCA;EACI,sBAAc;EACd,gBAAY;AVuiChB;AUpiCA;EACI,qBAAc;EACd,WAAM;EACN,kBAAU;AVsiCd;AUniCA;EACI,gBAAY;AVqiChB;AWxmCI;EACI,cAAQ;EACR,WAAM;EACN,gBAAU;AX0mClB;AY9mCA;EACI,mBAAc;EACd,kBAAa;AZgnCjB;AY7mCI;EACI,eAAU;EACV,UAAQ;AZ+mChB;AarnCI;EACI,kBAAS;AbunCjB;AarnCQ;EACI,aAAQ;EACR,mBAAY;EACZ,8BAAgB;AbunC5B;AapnCY;EACI,4CAAc;EACd,eAAU;AbsnC1B;Ac/nCQ;EACI,eAAU;AdioCtB;Ac7nCI;EACI,aAAQ;EACR,qCAAsB;EACtB,SAAI;EACJ,cAAY;EACZ,eAAa;EACb,+BAAe;Ad+nCvB;Ac7nCQ;EACI,eAAU;EACV,eAAa;EACb,gBAAc;EACd,2BAAc;Ad+nC1B;Ac7nC4B;EAEpB;IACI,gDAAsB;Ed8nChC;AACF;Ac7nC4B;EAEpB;IACI,gDAAsB;Ed8nChC;AACF;Ac3nCI;EACI,aAAQ;EACR,qCAAsB;EACtB,SAAI;EACJ,cAAY;EACZ,eAAa;Ad6nCrB;Ac3nCQ;EACI,eAAU;EACV,eAAa;EACb,gBAAc;EACd,2BAAc;Ad6nC1B;Ac3nC4B;EAEpB;IACI,gDAAsB;Ed4nChC;AACF;Ae7qCQ;EACI,cAAQ;Af+qCpB;Ae7qCY;EACI,qBAAgB;Af+qChC;Ae7qCQ;EACI,cAAQ;EACR,eAAU;Af+qCtB;Ae7qCI;EACI,eAAO;EACP,kBAAS;EACT,qBAAQ;EACR,sDAAiB;EACjB,YAAO;EACP,kBAAc;EACd,eAAU;EACV,WAAM;EACN,WAAM;EACN,YAAO;EACP,gBAAS;Af+qCjB;Ae7qCQ;EACI,kBAAS;EACT,QAAM;EACN,YAAQ;EACR,WAAM;EACN,UAAQ;Af+qCpB;Ae7qCY;EACI,eAAO;Af+qCvB;Ae7qCQ;EACI,kBAAS;EACT,QAAM;EACN,YAAQ;EACR,kBAAW;EACX,kBAAU;EACV,iBAAY;EACZ,WAAM;EACN,YAAO;Af+qCnB;Ae5qCA;EACI,uCAAiC;EACjC,aAAQ;EACR,gDAAsB;EACtB,oBAAgB;EAChB,iBAAa;EACb,gBAAO;EACP,cAAQ;Af8qCZ;Ae5qCI;EACI,4DAAiB;EACjB,mDAAM;Af8qCd;Ae5qCI;EACI,kBAAS;EACT,4BAAW;EACX,gBAAW;EACX,cAAQ;Af8qChB;Ae5qCQ;EACI,YAAQ;Af8qCpB;Ae5qCQ;EACI,UAAQ;Af8qCpB;Ae5qCY;;EACI,cAAQ;EACR,kBAAS;EACT,QAAM;Af+qCtB;Ae7qCY;EACI,uCAAW;EACX,YAAQ;Af+qCxB;Ae7qCY;EACI,8BAAO;EACP,aAAQ;Af+qCxB;Ae7qCY;EACI,UAAQ;Af+qCxB;Ae7qCQ;EACI,UAAQ;Af+qCpB;Ae7qCY;EACI,iBAAU;EACV,gBAAY;EACZ,yBAAe;Af+qC/B;Ae7qCQ;EACI,aAAQ;Af+qCpB;Ae7qCQ;EACI,YAAQ;Af+qCpB;Ae7qCQ;EACI,YAAQ;Af+qCpB;Ae7qCQ;EACI,YAAQ;Af+qCpB;Ae7qCQ;EACI,YAAQ;Af+qCpB;Ae7qCQ;EACI,YAAQ;Af+qCpB;Ae7qCQ;EACI,YAAQ;Af+qCpB;Ae1qCoB;EACI,0BAAwB;EACxB,6BAA2B;Af4qCnD;AetqCwB;EACI,eAAU;AfwqCtC;AerqCwB;;EACI,UAAQ;AfwqCpC;AetqC4B;;EACI,UAAQ;EACR,gBAAS;AfyqCzC;AenqCwB;EACI,eAAU;AfqqCtC;AenqCoB;EACI,gBAAc;AfqqCtC;AenqCwB;EACI,0BAAwB;EACxB,6BAA2B;AfqqCvD;AenqCQ;EACI,kBAAS;AfqqCrB;AenqCQ;;EACI,kBAAS;EACT,WAAQ;AfsqCpB;AepqCQ;EACI,iBAAY;EACZ,iBAAU;EACV,qDAAQ;AfsqCpB;AepqCY;EACI,cAAQ;EACR,kBAAS;EACT,QAAM;EACN,8BAAiB;EACjB,YAAQ;AfsqCxB;AepqCQ;EACI,gBAAW;EACX,SAAO;EACP,iBAAQ;AfsqCpB;AepqCY;EACI,iBAAU;EACV,WAAM;EACN,WAAM;EACN,mDAAc;EACd,kDAAa;AfsqC7B;AepqCgB;EACI,sBAAc;AfsqClC;AejqC4B;EACI,uHAA8J;AfmqC9L;AepqC4B;EACI,uHAA8J;AfsqC9L;AevqC4B;EACI,uHAA8J;AfyqC9L;Ae1qC4B;EACI,uHAA8J;Af4qC9L;Ae7qC4B;EACI,uHAA8J;Af+qC9L;AehrC4B;EACI,wHAA8J;AfkrC9L;AenrC4B;EACI,wHAA8J;AfqrC9L;AehrC4B;EACI,gFAAuH;AfkrCvJ;AenrC4B;EACI,gFAAuH;AfqrCvJ;AetrC4B;EACI,gFAAuH;AfwrCvJ;AezrC4B;EACI,gFAAuH;Af2rCvJ;Ae5rC4B;EACI,gFAAuH;Af8rCvJ;Ae/rC4B;EACI,iFAAuH;AfisCvJ;AelsC4B;EACI,iFAAuH;AfosCvJ;Ae/rCgC;EACI,gFAAuH;AfisC3J;AelsCgC;EACI,gFAAuH;AfosC3J;AersCgC;EACI,gFAAuH;AfusC3J;AexsCgC;EACI,gFAAuH;Af0sC3J;Ae3sCgC;EACI,gFAAuH;Af6sC3J;Ae9sCgC;EACI,iFAAuH;AfgtC3J;AejtCgC;EACI,iFAAuH;AfmtC3J;Ae9sC4B;EACI,gFAAiH;AfgtCjJ;AejtC4B;EACI,gFAAiH;AfmtCjJ;AeptC4B;EACI,gFAAiH;AfstCjJ;AevtC4B;EACI,gFAAiH;AfytCjJ;Ae1tC4B;EACI,gFAAiH;Af4tCjJ;Ae7tC4B;EACI,gFAAiH;Af+tCjJ;AehuC4B;EACI,gFAAiH;AfkuCjJ;Ae7tCgC;EACI,gFAA6G;Af+tCjJ;AehuCgC;EACI,gFAA6G;AfkuCjJ;AenuCgC;EACI,gFAA6G;AfquCjJ;AetuCgC;EACI,gFAA6G;AfwuCjJ;AezuCgC;EACI,gFAA6G;Af2uCjJ;Ae5uCgC;EACI,gFAA6G;Af8uCjJ;Ae/uCgC;EACI,gFAA6G;AfivCjJ;Ae/uCgB;;EAEI,eAAa;AfivCjC;Ae/uCoB;;EACI,yBAAuB;EACvB,4BAA0B;EAC1B,UAAQ;AfkvChC;AehvCwB;;EACI,UAAQ;AfmvCpC;AejvCgB;EACI,kBAAS;EACT,cAAQ;EACR,sBAAiB;EACjB,kEAAY;EACZ,WAAM;EACN,qDAAQ;EACR,4CAAW;AfmvC/B;AejvCoB;;EACI,qBAAgB;AfovCxC;AelvCwB;;EACI,aAAQ;AfqvCpC;AenvCoB;EACI,cAAQ;EACR,kBAAS;EACT,QAAM;EACN,6DAAiB;EACjB,WAAM;EACN,YAAO;EACP,YAAQ;EACR,8CAAW;AfqvCnC;AenvCoB;EACI,cAAQ;EACR,mBAAY;EACZ,gBAAS;EACT,uBAAc;AfqvCtC;AenvCoB;EACI,iBAAU;EACV,aAAQ;AfqvChC;AenvCgB;EACI,kBAAW;EACX,qBAAc;AfqvClC;AenvCoB;EACI,4CAAc;EACd,eAAU;EACV,WAAM;AfqvC9B;AenvCA;EACI,oBAAe;EACf,eAAS;EACT,aAAQ;EACR,4CAAc;EACd,gBAAU;EACV,gBAAU;EACV,UAAQ;EACR,UAAQ;EACR,kBAAW;EACX,gBAAW;EACX,0BAAU;EACV,qIAA6C;AfqvCjD;AenvCI;;EAEI,mBAAW;AfqvCnB;AenvCI;EACI,oBAAe;EACf,UAAQ;EACR,wBAAU;EACV,6GAA6C;AfqvCrD;AenvCI;EACI,oBAAe;EACf,UAAQ;EACR,0BAAU;AfqvClB;AenvCI;EACI,oBAAe;EACf,UAAQ;EACR,kBAAW;EACX,0BAAU;AfqvClB;AenvCI;EACI,gBAAW;EACX,sBAAO;EACP,4CAAc;EACd,uCAAW;EACX,aAAQ;AfqvChB;AelvCY;EACI,cAAQ;EACR,eAAU;EACV,WAAM;EACN,YAAO;EACP,cAAO;AfovCvB;AgBjjDQ;EACI,WAAM;EACN,YAAU;AhBmjDtB;AgBjjDI;EACI,cAAQ;EACR,eAAU;EACV,gBAAS;EACT,uBAAc;EACd,mBAAY;AhBmjDpB;AiB7jDQ;EACI,cAAQ;AjB+jDpB;AiB7jDI;EACI,aAAQ;AjB+jDhB;AiB5jDQ;EACI,aAAQ;EACR,mBAAY;EACZ,QAAI;AjB8jDhB;AiBxjDgB;;EACI,aAAQ;AjB2jD5B;AiBtjDgB;;EACI,aAAQ;AjByjD5B;AiBvjDI;EACI,sBAAgB;AjByjDxB;AiBvjDQ;EACI,gCAAiB;EACjB,YAAO;EACP,cAAY;EACZ,WAAM;EACN,YAAO;AjByjDnB","sourcesContent":["/* Stylus Helper Styles */\r\n@import '_mixins/*';\r\n@import '_variables';\r\n@import '_utilities';\r\n\r\n/* Universal Styles */\r\n@import '_universal';\r\n\r\n.p3-events-plugin\r\n\r\n    /* Site Styles */\r\n    @import '_global';\r\n    @import '_print';\r\n    //@import '_type';\r\n    @import '_elements/**/*';\r\n    @import '_vendors/**/*';\r\n    @import 'views/**/*';","fade-in($duration = 1s)\r\n    animation fadeIn var(--p3events-easing)\r\n    animation-fill-mode forwards\r\n    animation-duration $duration\r\n\r\nfade-out($duration = 1s)\r\n    animation fadeOut var(--p3events-easing)\r\n    animation-fill-mode forwards\r\n    animation-duration $duration\r\n\r\nspin-and-grow($duration = 1s)\r\n    animation spin-grow var(--p3events-easing)\r\n    animation-fill-mode forwards\r\n    animation-duration $duration\r\n    animation-iteration-count infinite\r\n    backface-visibility hidden\r\n\r\ngrow-in($duration = 1s)\r\n    animation grow var(--p3events-easing)\r\n    animation-fill-mode forwards\r\n    animation-duration $duration\r\n\r\nfade-in-delay($duration = 1s, $delay = 0)\r\n    animation fadeIn var(--p3events-easing)\r\n    animation-fill-mode forwards\r\n    animation-duration $duration\r\n    animation-delay $delay\r\n\r\nheartbeat()\r\n    transform translate(-50%, -50%) scale(0.75)\r\n    animation heartbeat var(--p3events-easing)\r\n    animation-iteration-count infinite\r\n    animation-duration 3s\r\n\r\npulse()\r\n    animation pulse var(--p3events-easing)\r\n    animation-duration 2s\r\n\r\n@keyframes heartbeat\r\n    0% {\r\n        transform translate(-50%, -50%) scale(0.75)\r\n    }\r\n\r\n    20% {\r\n        transform translate(-50%, -50%) scale(.75)\r\n    }\r\n    23% {\r\n        transform translate(-50%, -50%) scale(1)\r\n    }\r\n    26% {\r\n        transform translate(-50%, -50%) scale(0.75)\r\n    }\r\n\r\n    27% {\r\n        transform translate(-50%, -50%) scale(.75)\r\n    }\r\n    29% {\r\n        transform translate(-50%, -50%) scale(1)\r\n    }\r\n    31% {\r\n        transform translate(-50%, -50%) scale(.8)\r\n    }\r\n\r\n    100% {\r\n        transform translate(-50%, -50%) scale(0.75)\r\n    }\r\n\r\n@keyframes pulse {\r\n    0% {\r\n        transform: translate(-50%, -50%) rotate(0) scale(0);\r\n        opacity: 1;\r\n    }\r\n    50% {\r\n        transform: translate(-50%, -50%) rotate(var(--rotate)) scale(1);\r\n        opacity: 0;\r\n    }\r\n    100% {\r\n        transform: translate(-50%, -50%) rotate(0) scale(2);\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n@keyframes fadeIn\r\n    from {\r\n        opacity 0\r\n    }\r\n    to {\r\n        opacity 1\r\n    }\r\n\r\n@keyframes fadeOut\r\n    from {\r\n        opacity 1\r\n    }\r\n    to {\r\n        opacity 0\r\n    }\r\n\r\n@keyframes grow\r\n    from {\r\n        transform scale(.1)\r\n    }\r\n    to {\r\n        transform scale(1)\r\n    }\r\n\r\n@keyframes poof\r\n    from {\r\n        transform scale(0) rotate(0deg)\r\n        opacity 1\r\n    }\r\n    to {\r\n        transform scale(1) rotate(720deg)\r\n        opacity 0\r\n    }\r\n\r\n@keyframes spin\r\n    from {\r\n        transform rotate(0deg)\r\n    }\r\n    to {\r\n        transform rotate(360deg)\r\n    }\r\n\r\n@keyframes spin-grow\r\n    0% {\r\n        transform rotate(0deg) scale(1) translateZ(0)\r\n    }\r\n    50% {\r\n        transform rotate(360deg) scale(3) translateZ(0)\r\n    }\r\n    100% {\r\n        transform rotate(0deg) scale(1) translateZ(0)\r\n    }\r\n\r\n@keyframes gradient\r\n    0% {\r\n        background-position: 0 50%;\r\n    }\r\n    50% {\r\n        background-position: 100% 50%;\r\n    }\r\n    100% {\r\n        background-position: 0 50%;\r\n    }\r\n","&:root\r\n\r\n    // Anatomy of a variable:\r\n    // --p3events-{type}-{property}-{modifier}\r\n\r\n    // Utility Colors\r\n    --p3events-color-text-base: #000000\r\n    --p3events-color-black: #000000\r\n    --p3events-color-white: #ffffff\r\n\r\n    // Color Palette\r\n    --p3events-color-primary: #12543b\r\n    --p3events-color-secondary: #7b3219\r\n    --p3events-color-accent: #ffe4a8\r\n    --p3events-color-neutral: #ffffff\r\n    --p3events-color-canvas: #061733\r\n    --p3events-color-canvas-darker: #0c1424\r\n    --p3events-color-canvas-lighter: #264773\r\n    --p3events-color-success: #2d7b59\r\n    --p3events-color-warning: #a02327\r\n    --p3events-color-error: #473362\r\n\r\n    // Base Values\r\n    --p3events-font-family: \"Noto Sans\", sans-serif\r\n    --p3events-font-family-alt: \"Dosis\", serif\r\n    --p3events-font-family-headings: \"Signika\", serif\r\n    --p3events-font-family-stylish: \"Permanent Marker\", serif\r\n    --p3events-font-family-icon: 'Font Awesome 6 Pro', 'Font Awesome 6 Free'\r\n    --p3events-font-family-icon-brands: 'Font Awesome 6 Brands'\r\n    --p3events-base-text-color: var(--p3events-color-canvas-contrast)\r\n    --p3events-base-text-color-alt: var(--p3events-color-secondary)\r\n    --p3events-icon-font-size: 1rem\r\n\r\n    // Button Values\r\n    --p3events-btn-icon-font-size: toRem(24px)\r\n    --p3events-btn-bg-depth-shadow: var(--p3events-color-black)\r\n    --p3events-btn-bg-depth-border: var(--p3events-color-black)\r\n    --p3events-btn-bg-depth-shadow-opacity: .1\r\n    --p3events-btn-bg-depth-border-opacity: .15\r\n    --p3events-btn-bg-depth-shadow-blend: overlay\r\n    --p3events-btn-bg-depth-border-blend: overlay\r\n    --p3events-btn-bg-depth-shadow-hover: var(--p3events-color-white)\r\n    --p3events-btn-bg-depth-border-hover: var(--p3events-color-white)\r\n    --p3events-btn-bg-depth-shadow-opacity-hover: .15\r\n    --p3events-btn-bg-depth-border-opacity-hover: .5\r\n    --ll-btn-ripple-color: rgba(255, 255, 255, .25)\r\n\r\n    // Utility Values\r\n    --p3events-easing: cubic-bezier(0.23, 1, 0.32, 1)\r\n    --p3events-transition-timing: 0.25s\r\n    --p3events-transition: var(--p3events-transition-timing) var(--p3events-easing)\r\n    --p3events-border-radius: 12px\r\n    --p3events-pulse-bg-color: var(--p3events-color-canvas-lighter)\r\n    --p3events-pulse-max-size: 72px\r\n\r\n    // Box Shadows\r\n    --p3events-box-shadow: 0 0 8px rgba(0, 0, 0, .5)\r\n    --p3events-box-shadow-light: 0 2px 4px rgba(0, 0, 0, .1)\r\n    --p3events-box-shadow-bottom: 0 8px 8px -8px rgba(0, 0, 0, .5)\r\n\r\n    // Global Values\r\n    --p3events-body-font-family: var(--p3events-font-family)\r\n    --p3events-body-font-size: toRem(18px)\r\n    --p3events-link-color: #aaa\r\n    --p3events-link-color-hover: var(--p3events-color-secondary)\r\n\r\n    // Container Values\r\n    //--p3events-contain-mobile: 576px\r\n    //--p3events-contain-mobile-up: 576px\r\n    //--p3events-contain-tablet-portrait-up: 576px\r\n    //--p3events-contain-tablet-landscape-up: 576px\r\n    //--p3events-contain-desktop-up: 576px\r\n    //--p3events-contain-desktop-big-up: 576px\r\n    --p3events-contain-margin: 1rem\r\n    --p3events-contain-tablet-portrait-margin: calc(7.5% - 16px)\r\n    --p3events-contain-tablet-landscape-margin: var(--p3events-contain-tablet-portrait-margin)\r\n    --p3events-contain-desktop-margin: 5%\r\n\r\n    // Header\r\n    --p3events-header-bg-color: var(--p3events-color-canvas-darker)\r\n    --p3events-header-border-bottom-width: 3px\r\n    --p3events-header-height-mobile: toRem(96px)\r\n    --p3events-header-height: toRem(125px)\r\n    --p3events-site-links-item-padding: 1.5rem\r\n    --p3events-site-links-profile-icon-color: var(--p3events-color-accent)\r\n    --p3events-cart-icon-bg-color: var(--p3events-color-canvas-lighter)\r\n    --p3events-cart-icon-bg-opacity: .1\r\n\r\n    // Banner\r\n    --p3events-banner-height: toRem(400px)\r\n\r\n    // Navigation\r\n    --p3events-navigation-height-mobile: calc(100dvh - var(--p3events-header-height-mobile))\r\n    --p3events-navigation-height: calc(100dvh - var(--p3events-header-height))\r\n    --p3events-navigation-height-admin-mobile: calc(100dvh - (var(--p3events-header-height-mobile) + 46px))\r\n    --p3events-navigation-height-admin: calc(100dvh - (var(--p3events-header-height) + 32px))\r\n    --p3events-navigation-top-mobile: var(--p3events-header-height-mobile)\r\n    --p3events-navigation-top: var(--p3events-header-height)\r\n    --p3events-navigation-top-admin-mobile: calc(var(--p3events-header-height-mobile) + 46px)\r\n    --p3events-navigation-top-admin: calc(var(--p3events-header-height) + 32px)\r\n\r\n    // Page\r\n    --p3events-page-content-padding: 2rem\r\n\r\n    // Headings\r\n    --p3events-heading-font-family: var(--p3events-font-family)\r\n    --p3events-h1-font-family: var(--p3events-heading-font-family)\r\n    --p3events-h2-font-family: var(--p3events-heading-font-family)\r\n    --p3events-h3-font-family: var(--p3events-heading-font-family)\r\n    --p3events-h4-font-family: var(--p3events-heading-font-family)\r\n    --p3events-h5-font-family: var(--p3events-heading-font-family)\r\n    --p3events-h6-font-family: var(--p3events-heading-font-family)\r\n    --p3events-h1-font-size: 2.25rem\r\n    --p3events-h2-font-size: 2rem\r\n    --p3events-h3-font-size: 1.75rem\r\n    --p3events-h4-font-size: 1.5rem\r\n    --p3events-h5-font-size: 1.32rem\r\n    --p3events-h6-font-size: 1.12rem\r\n    --p3events-h1-font-size-mobile: 2rem\r\n    --p3events-h2-font-size-mobile: 1.75rem\r\n    --p3events-h3-font-size-mobile: 1.5rem\r\n    --p3events-h4-font-size-mobile: 1.32rem\r\n    --p3events-h5-font-size-mobile: 1.12rem\r\n    --p3events-h6-font-size-mobile: 1rem\r\n    --p3events-h1-font-weight: 700\r\n    --p3events-h2-font-weight: 500\r\n    --p3events-h3-font-weight: 500\r\n    --p3events-h4-font-weight: 400\r\n    --p3events-h5-font-weight: 300\r\n    --p3events-h6-font-weight: 700\r\n    --p3events-h1-text-color: var(--p3events-base-text-color)\r\n    --p3events-h2-text-color: var(--p3events-base-text-color)\r\n    --p3events-h3-text-color: var(--p3events-base-text-color-alt)\r\n    --p3events-h4-text-color: var(--p3events-base-text-color)\r\n    --p3events-h5-text-color: var(--p3events-base-text-color-alt)\r\n    --p3events-h6-text-color: var(--p3events-base-text-color)\r\n    --p3events-h1-text-transform: uppercase\r\n    --p3events-h2-text-transform: none\r\n    --p3events-h3-text-transform: none\r\n    --p3events-h4-text-transform: none\r\n    --p3events-h5-text-transform: none\r\n    --p3events-h6-text-transform: uppercase\r\n    --p3events-h1-font-weight-white: var(--p3events-h1-font-weight)\r\n    --p3events-h2-font-weight-white: 700\r\n    --p3events-h3-font-weight-white: 700\r\n    --p3events-h4-font-weight-white: var(--p3events-h4-font-weight)\r\n    --p3events-h5-font-weight-white: var(--p3events-h5-font-weight)\r\n    --p3events-h6-font-weight-white: var(--p3events-h6-font-weight)\r\n\r\n    // Events Month View\r\n    --p3events-month-picker-icon-bg: var(--primary-300)\r\n    --p3events-month-day-heading-bg-color: rgba(#212529, .5)\r\n    --p3events-month-day-heading-text-color: #fff",".p3-events-plugin\r\n\r\n    /* Container Helpers */\r\n\r\n    .contain\r\n        max-width-margins()\r\n\r\n    .contain-padding\r\n        max-width-padding()\r\n\r\n    .contain-sm\r\n        +on-sm-only()\r\n            max-width-margins()\r\n\r\n    .contain-md-down\r\n        +on-md-down()\r\n            max-width-margins()\r\n\r\n    .contain-padding-md-down\r\n        +on-md-down()\r\n            max-width-padding()\r\n\r\n    .contain-children\r\n        > *:not(.alignfull)\r\n            max-width-margins()\r\n\r\n    .contain-children-md-down\r\n        +on-md-down()\r\n            > *:not(.alignfull)\r\n                max-width-margins()\r\n\r\n    .contain-padding-children-md-down\r\n        +on-md-down()\r\n            > *:not(.alignfull)\r\n                max-width-padding()\r\n\r\n    .contain-lg\r\n        +on-lg()\r\n            max-width-margins()\r\n\r\n    .contain-start\r\n        max-width-margins-start()\r\n\r\n    .contain-end\r\n        max-width-margins-end()\r\n\r\n    .contain-padding-start\r\n        max-width-padding-start()\r\n\r\n    .contain-padding-end\r\n        max-width-padding-end()\r\n\r\n    .contain-nested-fullwidth\r\n        > .alignfull:not(.has-set-width)\r\n            padding-right 0\r\n            padding-left 0\r\n\r\n            > .inner\r\n                max-width-margins()\r\n                max-width none\r\n                width auto\r\n\r\n        > .alignfull.has-set-width\r\n            .set-width\r\n                max-width-margins()\r\n\r\n    .cover\r\n        position absolute\r\n        inset 0\r\n        opacity 0\r\n\r\n    /* Loading Icon */\r\n\r\n    .loader\r\n        position absolute\r\n        inset 0\r\n        display none\r\n        background-color rgba(255, 255, 255, .75)\r\n        border-radius 3px\r\n        justify-content center\r\n        align-items center\r\n        /*backdrop-filter blur(5px)*/\r\n        fade-in()\r\n\r\n    .loading\r\n        > .loader\r\n            z-index 100\r\n            display flex","max-width-margins()\r\n    margin-right var(--p3events-contain-margin)\r\n    margin-left var(--p3events-contain-margin)\r\n\r\n    +on-md()\r\n        margin-right var(--p3events-contain-tablet-portrait-margin)\r\n        margin-left var(--p3events-contain-tablet-portrait-margin)\r\n\r\n    +on-lg()\r\n        margin-right var(--p3events-contain-tablet-landscape-margin)\r\n        margin-left var(--p3events-contain-tablet-landscape-margin)\r\n\r\n    +on-xl()\r\n        margin-right var(--p3events-contain-desktop-margin)\r\n        margin-left var(--p3events-contain-desktop-margin)\r\n\r\nmax-width-margins-start()\r\n    margin-left var(--p3events-contain-margin)\r\n\r\n    +on-md()\r\n        margin-left var(--p3events-contain-tablet-portrait-margin)\r\n\r\n    +on-lg()\r\n        margin-left var(--p3events-contain-tablet-landscape-margin)\r\n\r\n    +on-xl()\r\n        margin-left var(--p3events-contain-desktop-margin)\r\n\r\nmax-width-margins-end()\r\n    margin-right var(--p3events-contain-margin)\r\n\r\n    +on-md()\r\n        margin-right var(--p3events-contain-tablet-portrait-margin)\r\n\r\n    +on-lg()\r\n        margin-right var(--p3events-contain-tablet-landscape-margin)\r\n\r\n    +on-xl()\r\n        margin-right var(--p3events-contain-desktop-margin)\r\n\r\nmax-width-padding()\r\n    padding-right var(--p3events-contain-margin)\r\n    padding-left var(--p3events-contain-margin)\r\n\r\n    +on-md()\r\n        padding-right var(--p3events-contain-tablet-portrait-margin)\r\n        padding-left var(--p3events-contain-tablet-portrait-margin)\r\n\r\n    +on-lg()\r\n        padding-right var(--p3events-contain-tablet-landscape-margin)\r\n        padding-left var(--p3events-contain-tablet-landscape-margin)\r\n\r\n    +on-xl()\r\n        padding-right var(--p3events-contain-desktop-margin)\r\n        padding-left var(--p3events-contain-desktop-margin)\r\n\r\nmax-width-padding-start()\r\n    padding-left var(--p3events-contain-margin)\r\n\r\n    +on-md()\r\n        padding-left var(--p3events-contain-tablet-portrait-margin)\r\n\r\n    +on-lg()\r\n        padding-left var(--p3events-contain-tablet-landscape-margin)\r\n\r\n    +on-xl()\r\n        padding-left var(--p3events-contain-desktop-margin)\r\n\r\nmax-width-padding-end()\r\n    padding-right var(--p3events-contain-margin)\r\n\r\n    +on-md()\r\n        padding-right var(--p3events-contain-tablet-portrait-margin)\r\n\r\n    +on-lg()\r\n        padding-right var(--p3events-contain-tablet-landscape-margin)\r\n\r\n    +on-xl()\r\n        padding-right var(--p3events-contain-desktop-margin)","/*Small devices (landscape phones, 576px and up)*/\r\n/* @deprecated on-mobile() */\r\non-sm-only()\r\n    @media (max-width 576px)\r\n        block\r\n\r\n/*Medium devices (tablets, 768px and up)*/\r\non-md-down()\r\n    @media (max-width 768px)\r\n        block\r\n\r\non-lg-down()\r\n    @media (max-width 992px)\r\n        block\r\n\r\n/*Small devices (landscape phones, 576px and up)*/\r\n/* @deprecated on-mobile-up() */\r\non-sm()\r\n    @media (min-width 576px)\r\n        block\r\n\r\n/*Medium devices (tablets, 768px and up)*/\r\n/* @deprecated on-tablet-portrait-up() */\r\non-md()\r\n    @media (min-width 768px)\r\n        block\r\n\r\n/* Large devices (desktops, 992px and up)*/\r\n/* @deprecated on-tablet-landscape-up() */\r\non-lg()\r\n    @media (min-width 992px)\r\n        block\r\n\r\n/* Extra large devices (large desktops, 1200px and up)*/\r\n/* @deprecated on-desktop-up() */\r\non-xl()\r\n    @media (min-width 1200px)\r\n        block\r\n\r\n/* Super extra large devices (large desktops, 1800px and up)*/\r\n/* @deprecated on-big-desktop-up() */\r\non-xxl()\r\n    @media (min-width 1800px)\r\n        block","html\r\n    scrollbar-gutter stable\r\n    scroll-behavior smooth",".p3-calendar\r\n    i\r\n        font-family 'Material Icons'\r\n        font-weight normal\r\n        font-style normal\r\n        font-size 1rem\r\n        line-height 1\r\n        display inline-block\r\n        text-transform none\r\n        letter-spacing normal\r\n        word-wrap normal\r\n        white-space nowrap\r\n        direction ltr\r\n        vertical-align -2px\r\n        text-rendering optimizeLegibility\r\n        font-feature-settings 'liga'\r\n\r\n    img\r\n        width 100%\r\n        height auto\r\n\r\n        &.not-loaded:not(.placeholder)\r\n            opacity 0\r\n\r\n        &.placeholder.not-loaded\r\n            background linear-gradient(45deg, var(--vn-color-canvas), var(--vn-color-primary), var(--vn-color-secondary))\r\n            background-size 500% 500%\r\n            animation gradient 10s var(--vn-easing) infinite\r\n\r\n            &.loaded\r\n                fade-in-delay()\r\n\r\n        &.loaded\r\n            fade-in-delay()\r\n\r\n    .container\r\n        > .inner\r\n            position relative\r\n\r\n    .glass\r\n        background none\r\n        border-radius var(--vn-border-radius)","@media print\r\n    @page\r\n        size landscape\r\n        margin 0\r\n\r\n    html, body\r\n        height 100dvh\r\n        overflow hidden\r\n        margin 0 !important\r\n        padding 0 !important\r\n\r\n\r\n    #site-header, #site-footer, .event-popover-container\r\n        display none\r\n\r\n    .p3-calendar\r\n        height 100%\r\n        max-height 100%\r\n        margin 0\r\n        overflow hidden\r\n        break-inside avoid\r\n        page-break-inside avoid\r\n\r\n    .calendar-events-view\r\n        .calendar-nav,\r\n        .calendar-month-picker,\r\n        .calendar-month-picker i,\r\n        .calendar-heading a.no-underline,\r\n        .day-events .event-thumbnail\r\n            display none\r\n\r\n        a\r\n            text-decoration none !important\r\n\r\n        .calendar-heading\r\n            padding-bottom 0 !important\r\n\r\n            h1\r\n                font-size 1.5rem\r\n                line-height 1\r\n                margin-bottom 0\r\n\r\n        .calendar\r\n            background transparent\r\n            border-right 1px solid rgba(0, 0, 0, .1)\r\n            border-bottom @border-right\r\n            grid-column-gap 0\r\n            grid-row-gap 0\r\n            -webkit-print-color-adjust exact !important\r\n            print-color-adjust exact !important\r\n\r\n            .day\r\n                background transparent\r\n                border-top 1px solid rgba(0, 0, 0, .1)\r\n                border-left @border-top\r\n                opacity 1 !important\r\n\r\n                &.today\r\n                    --primary var(--body-font-color)\r\n\r\n                    &:before, &:after\r\n                        content none !important\r\n\r\n                .day-label\r\n                    font-size .75rem\r\n                    padding 0 .25rem\r\n\r\n                    &:before\r\n                        opacity .05\r\n\r\n                .day-events\r\n                    .event\r\n                        a\r\n                            &:before\r\n                                border-top 1px solid var(--p3events-event-color, var(--primary))\r\n                                border-right @border-top\r\n                                border-bottom @border-top\r\n                                opacity .15\r\n\r\n                            span.event-time\r\n                                font-size .5rem !important\r\n\r\n                            span.event-date\r\n                                font-size .75rem !important",".missing-thumbnail\r\n    position relative\r\n    display inline-block\r\n\r\n    img\r\n        border-radius 50%\r\n\r\n    &:after\r\n        content '?'\r\n        position absolute\r\n        top 0\r\n        right 0\r\n        bottom 0\r\n        left 0\r\n        font-size 2em\r\n        text-shadow 1px 1px 0 rgba(0, 0, 0, .5)\r\n        line-height 48px\r\n        color var(--p3events-color-canvas)\r\n\r\n.missing-element\r\n    position relative\r\n    z-index 9999\r\n    background-color var(--p3events-color-canvas)\r\n    border 1px dashed var(--p3events-color-canvas-contrast)\r\n    border-radius 8px\r\n    color var(--p3events-color-text-base)\r\n    margin 1rem\r\n    padding 1rem\r\n\r\n    &:before\r\n        content 'Missing Template'\r\n        position absolute\r\n        top .15rem\r\n        left 1rem\r\n        font-size .75em\r\n        font-weight 700\r\n        text-transform uppercase\r\n        color var(--p3events-color-text-base)\r\n        opacity .25\r\n\r\n    pre\r\n        margin-bottom 0",".acf-map-container\r\n    border-top none\r\n    border-top-right-radius 0\r\n    border-top-left-radius 0\r\n\r\n.acf-map\r\n    width 100%\r\n    height var(--map-height, 400px)\r\n\r\n.acf-map-window\r\n    min-width 180px\r\n    padding 4px 2px 2px\r\n    font-size 14px\r\n    line-height 1.35\r\n\r\n\r\n.acf-map-window-title\r\n    margin-bottom 6px\r\n    color #222\r\n    font-weight 600\r\n\r\n\r\n.acf-map-window-link\r\n    display inline-flex\r\n    align-items center\r\n    color #007bff\r\n    font-size 13px\r\n    font-weight 600\r\n    text-decoration none\r\n\r\n\r\n.acf-map-window-linkhover\r\n    color #0056b3\r\n    text-decoration underline\r\n\r\n.gm-style .gm-style-iw-c\r\n    padding 12px !important\r\n    border-radius 8px !important\r\n\r\n\r\n.gm-style .gm-style-iw-d\r\n    overflow hidden !important\r\n\r\n.venue-map-list\r\n    display flex\r\n    flex-direction column\r\n    gap 1rem\r\n\r\n\r\n.venue-map-item\r\n    padding 1rem\r\n    border 1px solid #dee2e6\r\n    border-radius 0.5rem\r\n    background #fff\r\n\r\n\r\n.venue-map-title\r\n    margin-bottom 0.35rem\r\n    font-weight 600\r\n\r\n\r\n.venue-map-address\r\n    margin-bottom 0.5rem\r\n    color #666\r\n    font-size 0.95rem\r\n\r\n\r\n.venue-map-directions\r\n    font-weight 600\r\n",".modal\r\n    .modal-variable-width\r\n        display table\r\n        width auto\r\n        min-width 300px",".alignwide\r\n    padding-right 1rem\r\n    padding-left 1rem\r\n\r\n.wp-core-block.container\r\n    .container\r\n        max-width none\r\n        padding 0",".p3-events-shortcode\r\n    .item\r\n        position relative\r\n\r\n        .inner\r\n            display flex\r\n            align-items center\r\n            justify-content space-between\r\n\r\n        .event-cover\r\n            img\r\n                border-radius var(--p3events-border-radius)\r\n                max-width 64px","#event-attendees-modal\n\n    .event-attendee-avatar\n        img\n            min-width 40px\n\n#manage-attendees-modal\n\n    .modal-body > .row\n        display grid\n        grid-template-columns minmax(0, 1fr)\n        gap 1rem\n        margin-left 0\n        margin-right 0\n        padding-bottom 1rem !important\n\n        > [class*='col-']\n            max-width none\n            padding-left 0\n            padding-right 0\n            margin-bottom 0 !important\n\n    @media (min-width: 768px)\n\n        .modal-body > .row\n            grid-template-columns repeat(2, minmax(0, 1fr))\n\n    @media (min-width: 992px)\n\n        .modal-body > .row\n            grid-template-columns repeat(3, minmax(0, 1fr))\n\n.attendee-details-modal\n\n    .modal-body > .row\n        display grid\n        grid-template-columns minmax(0, 1fr)\n        gap 1rem\n        margin-left 0\n        margin-right 0\n\n        > [class*='col-']\n            max-width none\n            padding-left 0\n            padding-right 0\n            margin-bottom 0 !important\n\n    @media (min-width: 768px)\n\n        .modal-body > .row\n            grid-template-columns repeat(2, minmax(0, 1fr))\n",".calendar-heading\r\n    .calendar-nav\r\n        a\r\n            display block\r\n\r\n            &:hover\r\n                text-decoration none\r\n\r\n        i\r\n            display block\r\n            font-size 3rem\r\n\r\n    .calendar-month-picker\r\n        cursor pointer\r\n        position relative\r\n        display inline-block\r\n        background-color var(--p3events-month-picker-icon-bg)\r\n        border none\r\n        border-radius 50%\r\n        font-size 2rem\r\n        color #fff\r\n        width 2rem\r\n        height @width\r\n        overflow hidden\r\n\r\n        input\r\n            position absolute\r\n            inset 0\r\n            z-index 200\r\n            width 100%\r\n            opacity 0\r\n\r\n            &::-webkit-calendar-picker-indicator\r\n                cursor pointer\r\n\r\n        i\r\n            position absolute\r\n            inset 0\r\n            z-index 100\r\n            text-align center\r\n            font-size 1.25rem\r\n            line-height 2rem\r\n            width 100%\r\n            height 100%\r\n\r\n\r\n.calendar\r\n    --p3-events-month-event-padding: .5rem\r\n    display grid\r\n    grid-template-columns repeat(7, minmax(0, 1fr))\r\n    grid-column-gap 2px\r\n    grid-row-gap 2px\r\n    margin 0 0 3rem\r\n    padding 2px 0\r\n\r\n    .day-heading\r\n        background-color var(--p3events-month-day-heading-bg-color)\r\n        color var(--p3events-month-day-heading-text-color)\r\n\r\n    .day\r\n        position relative\r\n        background rgba(0, 0, 0, .05)\r\n        min-height 8rem\r\n        opacity .333\r\n\r\n        &.not-month\r\n            opacity .2\r\n\r\n        &.today\r\n            opacity 1\r\n\r\n            &:before, &:after\r\n                content '\\20'\r\n                position absolute\r\n                inset 0\r\n\r\n            &:before\r\n                box-shadow inset 0 0 2rem currentColor\r\n                opacity .1\r\n\r\n            &:after\r\n                border 1px solid currentColor\r\n                opacity .25\r\n\r\n            ~ *:not(.not-month)\r\n                opacity 1\r\n\r\n        &.day-heading\r\n            opacity 1\r\n\r\n            .day-label\r\n                font-size .86em\r\n                font-weight 700\r\n                text-transform uppercase\r\n\r\n        &.day-0\r\n            z-index 1000\r\n\r\n        &.day-1\r\n            z-index 900\r\n\r\n        &.day-2\r\n            z-index 800\r\n\r\n        &.day-3\r\n            z-index 700\r\n\r\n        &.day-4\r\n            z-index 600\r\n\r\n        &.day-5\r\n            z-index 500\r\n\r\n        &.day-6\r\n            z-index 400\r\n\r\n        .day-events\r\n            .event\r\n                &.multiday-start.continues\r\n                    a\r\n                        border-top-right-radius 0\r\n                        border-bottom-right-radius 0\r\n\r\n        &.day-0\r\n            .day-events\r\n                .event\r\n                    &.multiday-end\r\n                        > a\r\n                            max-width 100%\r\n\r\n                    &.multiday-end, &.multiday\r\n                        > a\r\n                            opacity 1\r\n\r\n                            span\r\n                                opacity 1\r\n                                overflow hidden\r\n\r\n        &.day-6\r\n            .day-events\r\n                .event\r\n                    &.multiday-start.continues\r\n                        > a\r\n                            max-width 100%\r\n\r\n                    &.multiday-start\r\n                        padding-right 0\r\n\r\n                        > a\r\n                            border-top-right-radius 0\r\n                            border-bottom-right-radius 0\r\n\r\n        > *\r\n            position relative\r\n\r\n        .day-label, .day-events\r\n            position relative\r\n            z-index 10\r\n\r\n        .day-label\r\n            user-select none\r\n            font-size .86em\r\n            padding .25rem var(--p3-events-month-event-padding)\r\n\r\n            &:before\r\n                content '\\20'\r\n                position absolute\r\n                inset 0\r\n                background-color currentColor\r\n                opacity .1\r\n\r\n        .day-events\r\n            list-style none\r\n            margin 0\r\n            padding .5rem 0\r\n\r\n            .event\r\n                font-size .86em\r\n                color white\r\n                width 100%\r\n                padding-right var(--p3-events-month-event-padding)\r\n                padding-left @padding-right\r\n\r\n                &:not(:last-child)\r\n                    margin-bottom .25rem\r\n\r\n                &.multiday\r\n                    > a\r\n                        for num in (1..7)\r\n                            &.duration-{num}\r\n                                width \"calc((100% * %s) + (var(--p3-events-month-event-padding) * %s) - var(--p3-events-month-event-padding) + (2px * %s))\" % ((num) ((num - 1) * 2) (num - 1))\r\n\r\n                &.multiday-start\r\n                    > a\r\n                        for num in (1..7)\r\n                            &.duration-{num}\r\n                                width \"calc((100% * %s) + (var(--p3-events-month-event-padding) * %s) + (2px * %s))\" % ((num) ((num * 2) - 2) (num - 1))\r\n\r\n                    &.continues\r\n                        > a\r\n                            for num in (1..7)\r\n                                &.duration-{num}\r\n                                    width \"calc((100% * %s) + (var(--p3-events-month-event-padding) * %s) + (2px * %s))\" % ((num) ((num * 2) - 1) (num - 1))\r\n\r\n                &.multiday-start.multiday\r\n                    > a\r\n                        for num in (1..7)\r\n                            &.duration-{num}\r\n                                width \"calc((100% * %s) + (var(--p3-events-month-event-padding) * %s) + (2px * %s))\" % ((num) (num - 1) (num - 1))\r\n\r\n                    &.continues\r\n                        > a\r\n                            for num in (1..7)\r\n                                &.duration-{num}\r\n                                    width \"calc((100% * %s) + (var(--p3-events-month-event-padding) * %s) + (2px * %s))\" % ((num) (num) (num - 1))\r\n\r\n                &.multiday-end,\r\n                &.multiday\r\n                    padding-left 0\r\n\r\n                    > a\r\n                        border-top-left-radius 0\r\n                        border-bottom-left-radius 0\r\n                        opacity 0\r\n\r\n                        span\r\n                            opacity 0\r\n\r\n                a\r\n                    position relative\r\n                    display block\r\n                    background-color #fff\r\n                    border-left 3px solid var(--p3events-event-color, var(--primary))\r\n                    color #000\r\n                    padding .25rem var(--p3-events-month-event-padding)\r\n                    transition color var(--p3events-transition)\r\n\r\n                    &:hover, &.hover\r\n                        text-decoration none\r\n\r\n                        &:before\r\n                            opacity .25\r\n\r\n                    &:before\r\n                        content '\\20'\r\n                        position absolute\r\n                        inset 0\r\n                        background-color var(--p3events-event-color, var(--primary))\r\n                        width 100%\r\n                        height 100%\r\n                        opacity .1\r\n                        transition opacity var(--p3events-transition)\r\n\r\n                    span\r\n                        display block\r\n                        white-space nowrap\r\n                        overflow hidden\r\n                        text-overflow ellipsis\r\n\r\n                    .event-time\r\n                        font-size .75em\r\n                        opacity .85\r\n\r\n                .event-thumbnail\r\n                    margin-top .5rem\r\n                    margin-bottom @margin-top\r\n\r\n                    img\r\n                        border-radius var(--p3events-border-radius)\r\n                        max-width 4rem\r\n                        width 100%\r\n\r\n.event-popover\r\n    pointer-events none\r\n    position fixed\r\n    z-index 1000\r\n    border-radius var(--p3events-border-radius)\r\n    min-width 220px\r\n    max-width 400px\r\n    padding 0\r\n    opacity 0\r\n    visibility hidden\r\n    overflow-y auto\r\n    transform translateY(4px)\r\n    transition opacity var(--p3events-transition), transform var(--p3events-transition), visibility 0s linear var(--p3events-transition)\r\n\r\n    &[data-state=\"open\"]\r\n    &[data-state=\"closing\"]\r\n        visibility visible\r\n\r\n    &[data-state=\"open\"]\r\n        pointer-events auto\r\n        opacity 1\r\n        transform translateY(0)\r\n        transition opacity var(--p3events-transition), transform var(--p3events-transition), visibility 0s linear 0s\r\n\r\n    &[data-state=\"closing\"]\r\n        pointer-events none\r\n        opacity 0\r\n        transform translateY(4px)\r\n\r\n    &[data-state=\"closed\"]\r\n        pointer-events none\r\n        opacity 0\r\n        visibility hidden\r\n        transform translateY(4px)\r\n\r\n    > .inner\r\n        background #fff\r\n        border 1px solid #ddd\r\n        border-radius var(--p3events-border-radius)\r\n        box-shadow 0 8px 20px rgba(0, 0, 0, .12)\r\n        padding 1rem\r\n\r\n        .event-thumbnail\r\n            img\r\n                display block\r\n                max-width 100%\r\n                width auto\r\n                height auto\r\n                margin 0 auto","#event-attendees-modal\n\n    .event-attendee-avatar-public\n        img\n            width 36px\n            min-width 0\n\n    .event-attendee-question-label\n        display block\n        max-width 8rem\n        overflow hidden\n        text-overflow ellipsis\n        white-space nowrap\n",".attendee-questions-modal\r\n    &.has-multiple\r\n        .hide-for-single\r\n            display block\r\n\r\n    .hide-for-single\r\n        display none\r\n\r\n    .carousel-item\r\n        .card-header\r\n            display flex\r\n            align-items center\r\n            gap 4px\r\n\r\n.event-attendee-questions\r\n    .carousel-item\r\n        &.active, &.carousel-item-right\r\n            &:first-child\r\n                .control-prev\r\n                    display none\r\n\r\n\r\n        &.active, &.carousel-item-left\r\n            &:last-child\r\n                .control-next\r\n                    display none\r\n\r\n    .carousel-indicators\r\n        justify-content start\r\n\r\n        > li\r\n            background-color var(--primary)\r\n            border none\r\n            text-indent 0\r\n            width auto\r\n            height auto\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
